"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2327],{

/***/ 66701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GoogleMapSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19231);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84849);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68779);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55791);
/* harmony import */ var _templates_property_partials_modals_ModalPois__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70263);
/* harmony import */ var _CustomModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89929);
/* harmony import */ var _GoogleMapContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29567);











function GoogleMapSection(props) {
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var container = props.container != undefined ? props.container : "container";
    var hidePin = props.hasOwnProperty("hidePin") ? props.hidePin : false;
    var randomizePin = props.app.builder.builder_propertylist_map_enable_randomize_pin;
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var inViewport = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_3__/* .useInViewport */ .NM)(myRef, options, config, props).inViewport;
    var property_lat = props.property_lat;
    var property_lng = props.property_lng;
    var googleMapShow = props.googleMapShow;
    var googleMapApiKey = props.googleMapApiKey;
    var hasGoogleMapApiKey = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidString */ .Z.isValidString(googleMapApiKey);
    var position = {
        lat: parseFloat(property_lat),
        lng: parseFloat(property_lng)
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    var viewPortResult = [];
    if (!inViewport) {
        viewPortResult[0] = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            style: {
                flexGrow: "1",
                height: "100%",
                background: "#f5f5f5"
            }
        });
        viewPortResult[1] = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            style: {
                flexGrow: "1",
                height: "100%",
                background: "#f5f5f5"
            }
        });
    } else {
        viewPortResult[0] = hasGoogleMapApiKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GoogleMapContent__WEBPACK_IMPORTED_MODULE_8__["default"], {
            app: props.app,
            map_pois: props.map_pois,
            center: position,
            randomizePin: randomizePin,
            hidePin: hidePin,
            propertyTitle: props.propertyTitle,
            propertyImages: props.propertyImages,
            propertyAddress: props.propertyAddress,
            googleMapApiKey: googleMapApiKey,
            inViewport: inViewport
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            title: "google maps",
            src: "https://maps.google.com/maps?q=".concat(property_lat, ",").concat(property_lng, "&z=14&output=embed"),
            width: "600",
            height: "364",
            style: {
                border: 0,
                width: "100%",
                height: "100%"
            },
            allowFullScreen: true,
            loading: "lazy",
            referrerPolicy: "no-referrer-when-downgrade"
        });
        viewPortResult[1] = (props.map_pois.length > 0 || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidObjString */ .Z.isValidObjString(props, "descAreaDistances")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "bg-master-lightest pb-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: container + " p-0 bg-master-lightest position-relative top-0 d-block h-auto p-t-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-design-color row justify-content-center w-100 m-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-8 col-sm-6 py-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "full-width text-center btn btn-bordered btn-bordered-design-color pointer d-flex flex-column align-items-center justify-content-center py-2",
                                // data-bs-toggle="modal" data-bs-target="#property_distances_directions"
                                onClick: handleShow,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_10__/* .faRoute */ .FpQ,
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "block-title mb-0",
                                        children: t("property.distancesDirections")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "hint-text small hidden-xs mb-0",
                                        children: t("property.distancesDirectionsTo")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                modalName: "property_distances_directions",
                                className: "slide_right",
                                modalSize: "lg",
                                closeModal: function() {
                                    handleClose();
                                },
                                show: show,
                                Title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-wrap text-left mt-0",
                                    children: t("property.distancesDirections")
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_property_partials_modals_ModalPois__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    descAreaDistances: props.descAreaDistances,
                                    map_pois: props.map_pois,
                                    handleClose: handleClose,
                                    property_lat: property_lat,
                                    property_lng: property_lng
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].googleMapsSectionInit */ .Z.googleMapsSectionInit(googleMapShow, property_lat, property_lng) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        ref: myRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "map",
                className: "bg-master-lightest",
                style: {
                    height: 365
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: container + " no-padding no-overflow h-100",
                    children: viewPortResult[0]
                })
            }),
            viewPortResult[1]
        ]
    });
}


/***/ }),

/***/ 22715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BedroomsModal; },
/* harmony export */   "r": function() { return /* binding */ displayableBedrooms; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84849);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55791);
/* harmony import */ var _api_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57093);
/* harmony import */ var _CustomModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89929);
/* harmony import */ var _properties_partials_SwipperWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82411);











var BED_LABELS = {
    bedroom_beds_king: "bed.king",
    bedroom_beds_queen: "bed.queen",
    bedroom_beds_double: "bed.double",
    bedroom_beds_single: "bed.single",
    bedroom_beds_sofabed: "bed.sofabed",
    bedroom_beds_murphy: "bed.murphy",
    bedroom_bunk: "bed.bunk",
    bedroom_baby_cribs: "bed.babyCrib"
};
function bedLines(bedroom) {
    if (bedroom == null) return [];
    return Object.keys(BED_LABELS).map(function(k) {
        return {
            label: BED_LABELS[k],
            n: parseInt(bedroom[k], 10) || 0
        };
    }).filter(function(x) {
        return x.n > 0;
    });
}
function featureValue(feature) {
    if (feature.feature_type === 7 && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(feature.feature_options)) {
        return feature.feature_options.map(function(o) {
            return o.option_value;
        }).join(", ");
    }
    if (feature.feature_type === 5) {
        return null;
    }
    return feature.feature_value;
}
function BedroomDetail(param) {
    var detail = param.detail;
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    if (detail == null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "p-t-20",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    height: 340,
                    className: "col-12 b-rad-lg d-block"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    height: 27,
                    className: "col-12 b-rad-lg d-block"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    height: 27,
                    className: "col-12 b-rad-lg d-block"
                })
            ]
        });
    }
    var beds = bedLines(detail);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-t-20",
        children: [
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(detail.media) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "m-b-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_properties_partials_SwipperWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    images: detail.media,
                    imageKey: "image",
                    slidesPerView: 1,
                    galleryHeight: "300px",
                    paginationBullets: true,
                    wrapperClassName: "Properties__gallery"
                })
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(detail.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-justify m-b-20",
                dangerouslySetInnerHTML: {
                    __html: detail.description
                }
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(detail.space_level_label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "m-b-10",
                children: [
                    "• ",
                    t("space.level"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: detail.space_level_label
                    })
                ]
            }),
            beds.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        className: "m-t-20 m-b-10",
                        children: t("bedroom.beds")
                    }),
                    beds.map(function(b) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "m-b-5",
                            children: [
                                "• ",
                                t(b.label),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: b.n
                                })
                            ]
                        }, b.label);
                    })
                ]
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(detail.features) && detail.features.map(function(group) {
                return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(group.features) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "m-t-20",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "block-title all-caps m-b-10",
                            children: group.group_title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: group.features.map(function(feature) {
                                var value = featureValue(feature);
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "col-6 m-b-5",
                                    children: [
                                        feature.feature_type === 5 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-success m-r-5",
                                            children: "✓"
                                        }),
                                        feature.feature_title,
                                        value != null && value !== "" ? ": " : "",
                                        value != null && value !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: value
                                        })
                                    ]
                                }, feature.feature_id);
                            })
                        })
                    ]
                }, group.group_id);
            })
        ]
    });
}
function displayableBedrooms(bedrooms) {
    return (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(bedrooms) ? bedrooms : []).filter(function(b) {
        return /^\d+$/.test(String(b.bedroom_id));
    }).filter(function(b) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(b.media) && b.media.some(function(m) {
            return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(m === null || m === void 0 ? void 0 : m.image);
        });
    });
}
function BedroomsModal(props) {
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var bedrooms = displayableBedrooms(props.bedrooms);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), activeId = ref[0], setActiveId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), detailsById = ref1[0], setDetailsById = ref1[1];
    var bedroomIdsKey = bedrooms.map(function(b) {
        return b.bedroom_id;
    }).join(",");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (activeId == null && bedrooms.length > 0) {
            setActiveId(bedrooms[0].bedroom_id);
        }
    }, [
        bedroomIdsKey
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!props.show || props.pageId == null || props.propertyId == null || bedrooms.length === 0) {
            return;
        }
        var cancelled = false;
        var pending = bedrooms.filter(function(b) {
            return detailsById[b.bedroom_id] == null;
        });
        if (pending.length === 0) return;
        var fetchAll = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                var next;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            next = {};
                            return [
                                4,
                                Promise.all(pending.map(function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(b) {
                                        var res, e;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        (0,_api_client__WEBPACK_IMPORTED_MODULE_4__/* .getPropertyBedroomById */ .Qv)(props.pageId, props.propertyId, b.bedroom_id)
                                                    ];
                                                case 1:
                                                    res = _state.sent();
                                                    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray(res === null || res === void 0 ? void 0 : res.bedrooms) && res.bedrooms[0] != null) {
                                                        next[b.bedroom_id] = res.bedrooms[0];
                                                    }
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(b) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state.sent();
                            if (!cancelled && Object.keys(next).length > 0) {
                                setDetailsById(function(prev) {
                                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev, next);
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAll() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAll();
        return function() {
            cancelled = true;
        };
    }, [
        props.show,
        props.pageId,
        props.propertyId,
        bedroomIdsKey
    ]);
    if (bedrooms.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        modalName: props.modalName || "bedrooms_modal",
        className: "slide_right",
        modalSize: "lg",
        closeModal: props.onClose,
        show: props.show,
        Title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: "text-overflow mt-0",
            children: props.title || t("property.bedrooms")
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "modal-body",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "nav-tabs-header nav-tabs-linetriangle",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "nav nav-tabs nav-tabs-linetriangle",
                        role: "tablist",
                        style: {
                            width: "auto",
                            whiteSpace: "nowrap",
                            display: "inline-block"
                        },
                        "data-init-reponsive-tabs": "dropdownfx",
                        children: bedrooms.map(function(bedroom, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "javascript:void(0)",
                                    className: "fs-12 " + (String(activeId) === String(bedroom.bedroom_id) ? "active" : ""),
                                    onClick: function() {
                                        return setActiveId(bedroom.bedroom_id);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(bedroom.bedroom_title) ? bedroom.bedroom_title : t("bedroom.numbered", {
                                            n: index + 1
                                        })
                                    })
                                })
                            }, bedroom.bedroom_id);
                        })
                    })
                }),
                activeId != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BedroomDetail, {
                    detail: detailsById[activeId]
                }, activeId)
            ]
        })
    });
}


/***/ }),

/***/ 62593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ContentWrapper = function(param) {
    var ContentRender = param.ContentRender;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: ContentRender
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentWrapper);


/***/ }),

/***/ 42327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(55791);
// EXTERNAL MODULE: ./components/GoogleMapSection.tsx
var GoogleMapSection = __webpack_require__(66701);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-collapsed/dist/react-collapsed.esm.js + 1 modules
var react_collapsed_esm = __webpack_require__(20704);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(23636);
// EXTERNAL MODULE: ./helpers/class/Methods.ts
var Methods = __webpack_require__(48078);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(77720);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var dist_es = __webpack_require__(19231);
// EXTERNAL MODULE: ./components/ReadMoreText.tsx
var ReadMoreText = __webpack_require__(34407);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/DetailDescViewPort.tsx











fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;



function DetailDesc(props) {
    var t = (0,i18n/* useT */.NT)();
    var ref = (0,react.useState)((0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    })), isPublicDomain = ref[0], setIsPublicDomain = ref[1];
    var ref1 = (0,react.useState)(0), publicDomain = ref1[0], setPublicDomain = ref1[1];
    (0,react.useEffect)(function() {
        setPublicDomain(isPublicDomain);
    }, [
        isPublicDomain,
        setPublicDomain
    ]);
    var _$config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, _$config, props).inViewport;
    var array = [
        {
            key: "guests",
            value: props.details.capacity
        },
        {
            key: "bedrooms",
            value: props.details.bedrooms
        },
        {
            key: "bathrooms",
            value: props.details.bathrooms
        },
        {
            key: "pools",
            value: props.details.pools
        },
        {
            key: "jacuzzi",
            value: props.details.jacuzzi
        }, 
    ];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isExpanded = ref2[0], setExpanded = ref2[1];
    var getCollapseProps = (0,react_collapsed_esm/* default */.Z)({
        isExpanded: isExpanded
    }).getCollapseProps;
    var ref3 = (0,react.useState)(props.details.property_title), propertyTitle = ref3[0], setPropertyTitle = ref3[1];
    var alternative_title = props.details.alternative_title;
    var normalizeText = function(text) {
        if (!text) return "";
        return text.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&").replace(/\s+/g, " ").trim();
    };
    var removeDescriptionFromBrief = function(descBrief, description) {
        if (!descBrief || !description) {
            return descBrief;
        }
        var normalizedDescription = normalizeText(description);
        var accumulatedText = "";
        var removeUntil = 0;
        var regex = /<p\b[^>]*>([\s\S]*?)<\/p>/gi;
        var match;
        while((match = regex.exec(descBrief)) !== null){
            var paragraphText = normalizeText(match[1]);
            if (!paragraphText) {
                continue;
            }
            accumulatedText = normalizeText("".concat(accumulatedText, " ").concat(paragraphText));
            // Τα paragraphs μέχρι στιγμής πρέπει να αποτελούν
            // την αρχή του description.
            if (!normalizedDescription.startsWith(accumulatedText)) {
                break;
            }
            removeUntil = regex.lastIndex;
            // Συμπληρώσαμε ακριβώς όλο το description.
            if (accumulatedText === normalizedDescription) {
                return descBrief.slice(removeUntil);
            }
        }
        return descBrief;
    };
    var descBrief = removeDescriptionFromBrief(props.details.desc_brief, props.details.description);
    (0,react.useEffect)(function() {
        if (alternative_title != undefined && publicDomain == 1) {
            if (alternative_title.length > 0) {
                setPropertyTitle(alternative_title);
            }
        }
    }, [
        publicDomain,
        setPropertyTitle,
        alternative_title
    ]);
    var b2description = props.details.b2b_description;
    var isHtmlEmpty = function(html) {
        if (!html) return true;
        var text = html.replace(/<[^>]*>/g, "").trim();
        return text === "";
    };
    var isPasswordProtectionEnabled = Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.passwordEnabled);
    var viewPortResult = null;
    viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: publicDomain == 1 && props.details.whitelabel_description.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreText["default"], {
                className: "text-md-justify",
                lines: 14,
                text: props.details.whitelabel_description,
                isDesktop: props.isDesktop
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-justify",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: props.details.motto
                        }),
                        Checkers/* default.isValidString */.Z.isValidString(props.details.motto) ? ". " : "",
                        props.details.description
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCollapseProps({})), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: Methods/* default.htmlTagReplacer */.Z.htmlTagReplacer(descBrief, "b", "strong")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: Methods/* default.htmlTagReplacer */.Z.htmlTagReplacer(props.details.desc_details, "b", "strong")
                                }
                            })
                        ]
                    })
                })),
                (props.details.desc_brief.length > 0 || props.details.desc_details.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-link text-link",
                        onClick: function() {
                            return setExpanded(function(value) {
                                return !value;
                            });
                        },
                        children: isExpanded ? t("common.readLess") : t("property.overview")
                    })
                })
            ]
        })
    });
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: myRef,
        id: "pro_detail_desc",
        className: "row full-width no-margin pb-5 test-class",
        children: [
            viewPortResult,
            isPasswordProtectionEnabled && !isHtmlEmpty(b2description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: b2description
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/CustomModal.tsx
var CustomModal = __webpack_require__(89929);
// EXTERNAL MODULE: ./components/templates/property/partials/gallery/GalleryItem.tsx
var GalleryItem = __webpack_require__(14708);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(28695);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/FeaturedImagesViewPort.tsx












var ModalPropertyImages = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 63644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63644)
            ];
        }
    },
    ssr: false
});
var FeaturedImages = function(props) {
    var t = (0,i18n/* useT */.NT)();
    var builderPropertiesGalleryMode = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_gallery_view_mode");
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("close"), modalState = ref1[0], setModalState = ref1[1];
    var handleShow = function(state) {
        setShow(true);
        setModalState(state);
    };
    var handleHide = function() {
        setShow(false);
        setModalState("close");
    };
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var viewPortResult = null;
    if (!inViewport) {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: myRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                height: 355,
                className: "col-12 b-rad-lg"
            })
        });
    } else {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row full-width no-margin",
                        children: [
                            props.images.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryItem/* default */.Z, {
                                    fancybox: "featured_images",
                                    index: key,
                                    image: item.image,
                                    imageThumb: item.image_thumb,
                                    caption: item.caption
                                }, item.image_id.toString());
                            }),
                            props.images_count > 6 && Checkers/* default.objChildExists */.Z.objChildExists(props, "all_images") && Checkers/* default.isValidArray */.Z.isValidArray(props.all_images) && props.all_images.length > 6 && props.all_images.slice(6).map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-fancybox": "featured_images",
                                    "data-src": item.image,
                                    "data-thumb": item.image_thumb
                                }, key.toString());
                            })
                        ]
                    })
                }),
                props.images_count > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "m-t-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn-link",
                                onClick: function() {
                                    return handleShow("property_featured_photos_modal");
                                },
                                children: t("property.seeAllPhotos")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                            modalName: "property_featured_photos_modal",
                            className: "slide_right",
                            modalSize: "lg",
                            closeModal: function() {
                                handleHide();
                            },
                            show: modalState === "property_featured_photos_modal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPropertyImages, {
                                all_images: props.all_images,
                                handleHide: handleHide
                            })
                        })
                    ]
                })
            ]
        });
    }
    var ref2 = (0,react.useState)(false), loadAll = ref2[0], setLoadAll = ref2[1];
    var showAllHandler = function() {
        if (loadAll) {
            var element = document.getElementById("main-gallery");
            var scrollToYOffset = element.getBoundingClientRect().y + window.scrollY - 80;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.scrollTo({
                top: scrollToYOffset,
                behavior: "instant"
            });
        }
        setLoadAll(!loadAll);
    };
    return builderPropertiesGalleryMode != 1 ? props.images_count >= 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "pro_detail_gallery",
        className: "row full-width no-margin pb-5",
        children: viewPortResult
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !inViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "p-b-65",
                id: "main-gallery",
                ref: myRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row clearfix",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 200,
                                    className: "col-md-4 "
                                })
                            })
                        ]
                    })
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "p-b-65",
                id: "main-gallery",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row clearfix",
                            children: props.all_images.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-xs-6 col-md-4 m-b-20" + (!loadAll && key > 5 ? " d-none" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "thumbnail",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryItem/* default */.Z, {
                                                fancybox: "featured_images",
                                                index: key,
                                                image: item.image_thumb,
                                                imageThumb: item.image_thumb,
                                                wrapImage: false,
                                                galleryClassName: "col-12",
                                                arrClassName: "ar-1-1",
                                                caption: item.caption
                                            }, item.image_id.toString())
                                        })
                                    })
                                });
                            })
                        }),
                        props.all_images.length > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row clearfix text-center p-t-30 m-b-60",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: showAllHandler,
                                    className: "btn btn-rounded btn-black btn-bordered",
                                    children: loadAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: t("common.showLess")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: t("common.loadMore")
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var FeaturedImagesViewPort = (FeaturedImages);

// EXTERNAL MODULE: ./node_modules/@mui/lab/Masonry/Masonry.js + 15 modules
var Masonry = __webpack_require__(45949);
;// CONCATENATED MODULE: ./components/templates/property/partials/features/FeaturedFeatures.tsx


function FeaturedFeatures(props) {
    var color_class = "text-master";
    switch(props.app.featuredAmenities){
        case 1:
        case "1":
            color_class = " text-white";
            break;
        case 2:
        case "2":
            color_class = " text-master";
            break;
        case 3:
        case "3":
            color_class = " text-design-color";
            break;
        default:
            color_class = " text-master";
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row mt-4",
        children: props.featured_features.map(function(feature) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: props.fourColumns ? "col-6 col-md-3" : "col-6 col-md-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: feature.feature_font_icon_new + color_class + " m-r-10"
                        }),
                        " ",
                        feature.feature_title
                    ]
                })
            }, feature.feature_id.toString());
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(12389);
;// CONCATENATED MODULE: ./components/templates/property/partials/features/FeatureDescription.tsx




fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;




function FeatureDescription(props) {
    var has_description = props.description != null && props.description != "";
    var has_extra_description = props.extra_description != null && props.extra_description != "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    props.hasOwnProperty("icon_info") && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faCheck */.LEp,
                        className: "text-master m-r-10",
                        size: "1x"
                    }),
                    has_description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: props.description
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            props.title,
                            props.hasOwnProperty("value") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ": ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: props.value
                                    })
                                ]
                            }) : props.hasOwnProperty("options") && Checkers/* default.isValidArray */.Z.isValidArray(props.options) && props.options.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        ": ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: option.option_value
                                        }, option.option_id.toString())
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }),
            props.hasOwnProperty("icon_info") && has_extra_description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    placement: "top",
                    title: props.extra_description,
                    componentsProps: {
                        tooltip: {
                            sx: {
                                backgroundColor: "#000",
                                color: "#ffffff",
                                boxShadow: "0px 0px 2px #000",
                                zIndex: "999999999999 !important"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faInfo */.YHc,
                                className: "text-master",
                                size: "1x"
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/templates/property/partials/features/FeatureType.tsx


function FeatureType(props) {
    var feature_type;
    switch(props.feature.feature_type.toString()){
        case "1":
        case "2":
            feature_type = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureDescription, {
                    description: props.feature.feature_description,
                    extra_description: props.feature.feature_extra_description,
                    value: props.feature.feature_value,
                    title: props.feature.feature_title
                })
            });
            break;
        case "5":
        case "6":
            feature_type = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureDescription, {
                    description: props.feature.feature_description,
                    extra_description: props.feature.feature_extra_description,
                    icon_info: true,
                    title: props.feature.feature_title
                })
            });
            break;
        case "7":
        case "8":
            feature_type = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureDescription, {
                    description: props.feature.feature_description,
                    extra_description: props.feature.feature_extra_description,
                    options: props.feature.feature_options,
                    title: props.feature.feature_title
                })
            });
            break;
    }
    return feature_type;
}

;// CONCATENATED MODULE: ./components/templates/property/partials/modals/ModalPropertyFeatures.tsx




fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;



function ModalPropertyFeatures(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modal-body",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: props.feature_groups.map(function(parent_group) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: parent_group.group.map(function(child_group) {
                        return child_group.features.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block-title p-b-15 text-black",
                                    children: [
                                        child_group.group_title,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faChevronRight */._tD,
                                            className: "text-black m-l-10 fw-normal fs-11",
                                            style: {
                                                verticalAlign: "initial"
                                            }
                                        })
                                    ]
                                }),
                                child_group.features.length > 0 && child_group.features.map(function(feature) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureType, {
                                            feature: feature
                                        })
                                    }, feature.feature_id.toString());
                                })
                            ]
                        }, child_group.group_id.toString());
                    })
                }, parent_group.group_id.toString());
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/FeaturesViewPort.tsx







fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;






function Features(props) {
    var t = (0,i18n/* useT */.NT)();
    var _$config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, _$config, props).inViewport;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    var ref1 = (0,react.useState)(null), activeGroup = ref1[0], setActiveGroup = ref1[1];
    var viewPortResult = null;
    var has_groups = Checkers/* default.objChildExistsAndIsValidArray */.Z.objChildExistsAndIsValidArray(props.features, "groups") && Checkers/* default.objChildExistsAndIsValidArray */.Z.objChildExistsAndIsValidArray(props.features.groups[0], "group");
    var has_featured_features = Checkers/* default.objChildExistsAndIsValidArray */.Z.objChildExistsAndIsValidArray(props.features, "featured_features");
    if (!inViewport) {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-9 col-sm-7 col-md-5 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 35,
                    className: "col-12 b-rad-lg mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-6 col-md-4 b-rad-md mb-2"
                })
            ]
        });
    } else {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "block-title m-t-40 hint-text no-margin",
                    children: t("property.facilities")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "m-t-5",
                    children: t("property.availableFacilities")
                }),
                has_featured_features ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedFeatures, {
                            app: props.app,
                            featured_features: props.features.featured_features,
                            feature_group: props.features.groups,
                            fourColumns: props.fourColumns
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn-link",
                                onClick: handleShow,
                                children: t("property.seeAllAmenities")
                            })
                        }),
                        has_groups && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                            modalName: "features_modal",
                            className: "slide_right",
                            modalSize: "lg",
                            closeModal: function() {
                                handleClose();
                            },
                            show: show,
                            Title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-left mt-0",
                                style: {
                                    whiteSpace: "normal"
                                },
                                children: t("property.availableFacilities")
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPropertyFeatures, {
                                feature_groups: props.features.groups,
                                handleClose: handleClose
                            })
                        })
                    ]
                }) : has_groups && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry/* default */.ZP, {
                            className: "mt-4",
                            columns: {
                                xs: 1,
                                sm: 2,
                                md: 3
                            },
                            spacing: 3,
                            children: props.features.groups[0].group.map(function(group) {
                                return group.features.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "block-title p-b-15 text-black",
                                            children: group.group_title
                                        }),
                                        group.features.map(function(feature) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureType, {
                                                feature: feature
                                            }, feature.feature_id.toString());
                                        })
                                    ]
                                }, group.group_id.toString());
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn-link",
                                        onClick: handleShow,
                                        children: t("property.seeAllAmenities")
                                    })
                                }),
                                has_groups && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                                    modalName: "features_modal",
                                    className: "slide_right",
                                    modalSize: "lg",
                                    closeModal: function() {
                                        handleClose();
                                    },
                                    show: show,
                                    Title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-left mt-0",
                                        style: {
                                            whiteSpace: "normal"
                                        },
                                        children: t("property.availableFacilities")
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPropertyFeatures, {
                                        feature_groups: props.features.groups,
                                        handleClose: handleClose
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return (has_featured_features || has_groups) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: props.isManager ? "pro_detail_amenities" : "facilities",
                className: "".concat(props.isManager ? "pb-5" : "pb-5 pt-4 "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row w-100 no-margin",
                    children: viewPortResult
                })
            }),
            activeGroup && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                modalName: "features_group_modal",
                className: "slide_right",
                modalSize: "lg",
                closeModal: function() {
                    return setActiveGroup(null);
                },
                show: true,
                Title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-left mt-0",
                    style: {
                        whiteSpace: "normal"
                    },
                    children: activeGroup.title
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPropertyFeatures, {
                    feature_groups: [
                        activeGroup
                    ],
                    handleClose: function() {
                        return setActiveGroup(null);
                    }
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/templates/properties/partials/SwipperWrapper.tsx
var SwipperWrapper = __webpack_require__(82411);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./components/templates/properties/partials/RightModal.tsx
var RightModal = __webpack_require__(24909);
// EXTERNAL MODULE: ./components/templates/properties/partials/ContentWrapper.tsx
var ContentWrapper = __webpack_require__(62593);
;// CONCATENATED MODULE: ./components/templates/properties/partials/SImpleContent.tsx


var SimpleContent = function(param) {
    var content = param.content, _extraContent = param.extraContent, extraContent = _extraContent === void 0 ? "" : _extraContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.isHtml */.Z.isHtml(content) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "m-t-20 m-b-20",
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "m-t-20 m-b-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: content
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-t-20 m-b-20",
                dangerouslySetInnerHTML: {
                    __html: extraContent
                }
            })
        ]
    });
};
/* harmony default export */ var SImpleContent = (SimpleContent);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
;// CONCATENATED MODULE: ./components/templates/property/partials/modals/ModalServices.tsx



// import Swiper core and required modules

// Import Swiper React components



// Import Swiper styles

// install Swiper modules
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Lazy */.oM
]);

function ModalServices(props) {
    var service = props.service;
    var images = props.service.service_images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modal-body",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        speed: 1000,
                        navigation: true,
                        pagination: true,
                        slidesPerView: 1,
                        autoplay: false,
                        className: "cursor-pointer mb-3",
                        style: {
                            height: 310
                        },
                        children: Checkers/* default.serviceImagesValid */.Z.serviceImagesValid(service) && images.map(function(slide, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    priority: index == 0,
                                    // loading={key == 0 ? 'eager' : 'lazy'}
                                    "data-src": slide.service_image,
                                    "data-fancybox": "modal-service-" + service.service_id,
                                    "data-caption": slide.service_image_caption,
                                    layout: "fill",
                                    sizes: "50vw",
                                    quality: "50",
                                    src: slide.service_image,
                                    alt: slide.caption ? slide.caption : "Slide-" + index,
                                    objectFit: "cover",
                                    placeholder: "blur",
                                    blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                })
                            }, slide.service_media_id.toString());
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: props.service.service_body
                        }
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var modals_ModalServices = (ModalServices);

;// CONCATENATED MODULE: ./components/templates/property/partials/services/included/Included.tsx






var Included = function(props) {
    var is_modal = function() {
        return Checkers/* default.objChildExists */.Z.objChildExists(props, "modal");
    };
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var handleHide = function() {
        setShowModal(function(prev) {
            return !prev;
        });
    };
    var service = props.service;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-6 thumbnail-wrapper bordered b-grey b-rad-sm pull-left",
                style: {
                    width: 120,
                    height: 120,
                    marginRight: 10
                },
                children: Checkers/* default.isValidArray */.Z.isValidArray(service.service_images) && Checkers/* default.isValidString */.Z.isValidString(service.service_images[0].service_image_square_thumb) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fixed",
                    width: 112,
                    height: 112,
                    src: service.service_images[0].service_image_square_thumb,
                    alt: service.service_images[0].service_image_caption ? Checkers/* default.removeEmojis */.Z.removeEmojis(service.service_images[0].service_image_caption) : "service-image-" + service.service_id
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-body pt-3 px-2 pb-0 text-left",
                children: !Checkers/* default.isValidString */.Z.isValidString(service.service_description) ? Checkers/* default.isValidString */.Z.isValidString(service.service_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-master",
                        children: service.service_title
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-master",
                            children: Checkers/* default.isValidString */.Z.isValidString(service.service_title) && service.service_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "notes hint-text small",
                            children: service.service_description
                        })
                    ]
                })
            }),
            is_modal && showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                modalName: "service-" + service.service_id,
                className: "slide_right",
                modalSize: "lg",
                closeModal: function() {
                    handleHide();
                },
                show: showModal,
                Title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-wrap text-left mt-0",
                            children: service.service_title
                        }),
                        Checkers/* default.isValidString */.Z.isValidString(service.service_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "hint-text text-left",
                            children: service.service_description
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_ModalServices, {
                    service: props.service
                })
            })
        ]
    });
};
/* harmony default export */ var included_Included = (Included);

;// CONCATENATED MODULE: ./components/templates/property/partials/services/ondemand/Ondemand.tsx






function Ondemand(props) {
    var service = props.service;
    var is_modal = function() {
        return Checkers/* default.objChildExists */.Z.objChildExists(props, "modal");
    };
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var handleHide = function() {
        setShowModal(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-header p-0",
                children: Checkers/* default.isValidArray */.Z.isValidArray(service.service_images) && Checkers/* default.isValidString */.Z.isValidString(service.service_images[0].service_image_square_thumb) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "responsive",
                    width: 300,
                    height: 300,
                    sizes: "40vw",
                    quality: "40",
                    className: "image",
                    objectFit: "cover",
                    src: service.service_images[0].service_image_square_thumb,
                    alt: service.service_images[0].service_image_caption ? Checkers/* default.removeEmojis */.Z.removeEmojis(service.service_images[0].service_image_caption) : "service-image-" + service.service_id
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-body pt-3 px-2 pb-0 text-left",
                children: Checkers/* default.isValidString */.Z.isValidString(service.service_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-master",
                        children: service.service_title
                    })
                })
            }),
            is_modal && showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                modalName: "service-" + service.service_id,
                className: "slide_right",
                modalSize: "lg",
                closeModal: function() {
                    handleHide();
                },
                show: showModal,
                Title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-wrap text-left mt-0",
                            children: service.service_title
                        }),
                        Checkers/* default.isValidString */.Z.isValidString(service.service_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "hint-text text-left",
                            children: service.service_description
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_ModalServices, {
                    service: props.service
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/templates/property/partials/services/SingleServiceContent.tsx












var SingleServiceContent = function(param) {
    var service = param.service, layout = param.layout, _useSwiper = param.useSwiper, useSwiper = _useSwiper === void 0 ? false : _useSwiper;
    var t = (0,i18n/* useT */.NT)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("close"), modalState = ref1[0], setModalState = ref1[1];
    var handleShow = function(state) {
        setShow(true);
        setModalState(state);
    };
    var handleHide = function() {
        setShow(false);
        setModalState("close");
    };
    var for_modal = {
        handleHide: handleHide,
        setModalState: setModalState
    };
    var col_class_name = "";
    var col_class_name_inner = "service-item-design-box m-b-15 m-r-5 ";
    var service_class_name = "";
    var service_component = null;
    var has_body = true //Checkers.isValidString( service.service_body );
    ;
    switch(layout){
        case "list":
            col_class_name = "col-12 col-sm-6 col-md-4 col-lg-6 px-0";
            service_class_name = "service-item color d-flex flex-row w-100 no-margin";
            service_component = /*#__PURE__*/ (0,jsx_runtime.jsx)(included_Included, {
                service: service
            });
            break;
        case "grid":
        case "carousel":
            col_class_name = "col-6 col-sm-3 p-l-0 p-r-0";
            col_class_name_inner += "p-0 ";
            service_class_name = "card w-100 bg-transparent border-0 shadow-none";
            service_component = /*#__PURE__*/ (0,jsx_runtime.jsx)(Ondemand, {
                service: service
            });
            break;
    }
    service_class_name += has_body ? " cursor-pointer" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: useSwiper ? "" : col_class_name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: col_class_name_inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: useSwiper ? "" : service_class_name,
                        onClick: has_body ? function() {
                            return handleShow("service-" + service.service_id);
                        } : undefined,
                        children: service_component
                    }),
                    has_body && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                        modalName: "service-" + service.service_id,
                        className: "slide_right",
                        Title: service.service_title,
                        modalSize: "lg",
                        loaderStatus: false,
                        closeModal: function() {
                            handleHide();
                        },
                        show: modalState === "service-" + service.service_id,
                        BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                            ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                        content: (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(service.schedule_cycle_value) ? service.schedule_cycle_value + " " : "") + service.schedule_cycle_label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                        images: service.service_images,
                                        galleryHeight: "285px",
                                        imageKey: "service_image",
                                        enableFancyBox: false
                                    }, "single-service-images-swiper"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                        content: service.service_body
                                    }),
                                    Checkers/* default.isValidString */.Z.isValidString(service.addon_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "btn btn-primary btn-design-color btn-lg p-r-15 p-l-15",
                                            href: service.addon_url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faLink */.nNP,
                                                    size: "1x"
                                                }),
                                                "\xa0",
                                                t("services.link")
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        })
                    }, 100)
                ]
            }, service.service_id.toString())
        })
    });
};
/* harmony default export */ var services_SingleServiceContent = (SingleServiceContent);

;// CONCATENATED MODULE: ./components/templates/property/partials/services/ServiceContent.tsx








var ServiceContent = function(param) {
    var type = param.type, services = param.services;
    var servicesLimit = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_limit");
    });
    var ref = (0,react.useState)(servicesLimit), currentServicesLimit = ref[0], setCurrentServicesLimit = ref[1];
    var servicesViewMoreButton = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_view_more_button");
    });
    var showAllHandler = function() {
        if (servicesLimit == currentServicesLimit) {
            setCurrentServicesLimit(null);
        } else {
            setCurrentServicesLimit(servicesLimit);
        }
    };
    var servicesOnRequestLayout = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_onrequest_services");
    });
    var servicesSpecialLayout = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_special_services");
    });
    var servicesIncludedLayout = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_included_services");
    });
    var layoutHandler = function(type) {
        if (type == "included") {
            return servicesIncludedLayout;
        } else if (type == "ondemand") {
            return servicesOnRequestLayout;
        } else if (type == "featured") {
            return servicesSpecialLayout;
        }
    };
    var layout = layoutHandler(type);
    var useSwiper = layout == "carousel";
    var serviceComponent = [];
    services.map(function(service, index) {
        serviceComponent.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(services_SingleServiceContent, {
                service: service,
                layout: layout,
                useSwiper: true
            })
        }, index));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: useSwiper ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                imageSlider: false,
                htmlSlides: serviceComponent,
                paginationBulletsEnabled: false,
                slidesPerView: 3.2,
                slidesPerViewLg: 3,
                slidesPerViewMd: 3,
                slidesPerViewSm: 2,
                slidesPerViewXs: 1.4,
                spaceBetween: 20,
                enableLoop: false,
                galleryHeight: "auto",
                wrapperClassName: "d-navigation ",
                enableFancyBox: false,
                centeredSlides: false
            }, "services-swiper-" + type)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row pt-4",
            children: [
                services.map(function(service, index) {
                    if (currentServicesLimit != null && index >= currentServicesLimit) {
                        return;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(services_SingleServiceContent, {
                        service: service,
                        layout: layout
                    }, index);
                }),
                Checkers/* default.isValidArray */.Z.isValidArray(services) && currentServicesLimit != null && currentServicesLimit < services.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row clearfix text-center p-t-30 m-b-60",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: showAllHandler,
                            className: "btn btn-rounded btn-black btn-bordered",
                            children: servicesViewMoreButton
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            ]
        })
    });
};
/* harmony default export */ var services_ServiceContent = (ServiceContent);

// EXTERNAL MODULE: ./components/templates/properties/partials/TabsContentWrapper.tsx
var TabsContentWrapper = __webpack_require__(9047);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ServicesViewPort.tsx










function Services(props) {
    var t = (0,i18n/* useT */.NT)();
    var isPublicDomain = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    }); // props.isDesktop;
    var ref = (0,react.useState)(1), publicDomain = ref[0], setPublicDomain = ref[1];
    var builderServicesLayout = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_layout");
    });
    (0,react.useEffect)(function() {
        setPublicDomain(isPublicDomain);
    }, [
        isPublicDomain,
        setPublicDomain
    ]);
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var ref1 = (0,react.useState)(true), servicesArrayLoading = ref1[0], setServicesArrayLoading = ref1[1];
    var ref2 = (0,react.useState)([]), servicesArray = ref2[0], setServicesArray = ref2[1];
    var viewPortResult = [];
    if (!inViewport) {
        viewPortResult[0] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-9 col-sm-7 col-md-5 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 180,
                    className: "col-12 b-rad-lg"
                })
            ]
        });
        viewPortResult[1] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-9 col-sm-7 col-md-5 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 180,
                    className: "col-12 b-rad-lg"
                })
            ]
        });
        viewPortResult[2] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-9 col-sm-7 col-md-5 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 180,
                    className: "col-12 b-rad-lg"
                })
            ]
        });
    } else {
        viewPortResult[0] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "block-title m-t-40 hint-text no-margin",
                    children: t("property.services")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "m-t-5",
                    children: t("property.includedServices")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "included",
                    services: props.services.included
                })
            ]
        });
        viewPortResult[1] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "m-t-5",
                    children: [
                        publicDomain == 1 ? "" : props.page_title,
                        "\xa0",
                        t("property.specialServices")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "featured",
                    services: props.services.featured
                })
            ]
        });
        viewPortResult[2] = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "m-t-5",
                    children: t("property.onRequest")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "ondemand",
                    services: props.services.ondemand
                })
            ]
        });
    }
    var getTabbedContent = function() {
        var result = [];
        if (Checkers/* default.objChildExists */.Z.objChildExists(props.services, "included") && props.services.included.length > 0) {
            result.push({
                tabId: "included",
                tabTitle: t("property.includedServices"),
                tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "included",
                    services: props.services.included
                })
            });
        }
        if (Checkers/* default.objChildExists */.Z.objChildExists(props.services, "featured") && props.services.featured.length > 0) {
            result.push({
                tabId: "featured",
                tabTitle: t("property.specialServices"),
                tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "featured",
                    services: props.services.featured
                })
            });
        }
        if (Checkers/* default.objChildExists */.Z.objChildExists(props.services, "ondemand") && props.services.ondemand.length > 0) {
            result.push({
                tabId: "ondemand",
                tabTitle: t("property.onRequest"),
                tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(services_ServiceContent, {
                    type: "ondemand",
                    services: props.services.ondemand
                })
            });
        }
        setServicesArrayLoading(false);
        setServicesArray(result);
    };
    (0,react.useEffect)(function() {
        if (servicesArrayLoading) {
            getTabbedContent();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: builderServicesLayout == "tabs" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: props.isManager ? "pro_detail_services" : "services",
                className: "pb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "block-title m-t-40 hint-text no-margin p-l-10",
                        children: t("property.services")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "m-t-5 p-l-10",
                        children: t("property.availableServices")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentWrapper/* default */.Z, {
                        data: servicesArray,
                        ReactComponentsArrayLoading: servicesArrayLoading,
                        responsiveDropdown: false
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: props.isManager ? undefined : "services",
            children: [
                Checkers/* default.objChildExists */.Z.objChildExists(props.services, "included") && props.services.included.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "pro_detail_services_included",
                    className: "pb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 no-margin",
                        children: viewPortResult[0]
                    })
                }),
                Checkers/* default.objChildExists */.Z.objChildExists(props.services, "featured") && props.services.featured.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "pro_detail_services_featured",
                    className: "pb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 no-margin",
                        children: viewPortResult[1]
                    })
                }),
                Checkers/* default.objChildExists */.Z.objChildExists(props.services, "ondemand") && props.services.ondemand.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "pro_detail_services_ondemand",
                    className: "pb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 no-margin",
                        children: viewPortResult[2]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(23077);
;// CONCATENATED MODULE: ./components/templates/properties/partials/FeaturesList.tsx





var FeaturesList = function(param) {
    var featureList = param.featureList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Checkers/* default.isValidArray */.Z.isValidArray(featureList) && featureList.map(function(featureGroup) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "block-title p-b-15 text-black",
                        children: [
                            featureGroup.group_title,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                className: "me-2",
                                icon: pro_solid_svg_icons/* faAngleRight */.yOZ
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row m-b-20",
                        children: featureGroup.features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            className: "me-2",
                                            icon: pro_solid_svg_icons/* faCheck */.LEp
                                        }),
                                        feature.feature_title,
                                        "\xa0",
                                        feature.feature_options != null && feature.feature_options.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: feature.feature_options[0].option_value
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: feature.feature_value != "1" && feature.feature_value != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: feature.feature_value
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        })
                                    ]
                                })
                            });
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var partials_FeaturesList = (FeaturesList);

;// CONCATENATED MODULE: ./components/templates/properties/partials/AttributesList.tsx


var AttributesList = function(param) {
    var data = param.data;
    var t = (0,i18n/* useT */.NT)();
    // useEffect(() => {
    //     console.log("forDebug", "spaceLevelLabel", data.space_level_label)
    // }, [data])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "m-t-20 m-b-40 row",
                children: [
                    data.space_position_label != undefined && data.space_position_label != null && data.space_position_label.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.position"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.space_position_label
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.space_level_label != undefined && data.space_level_label != null && data.space_level_label.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.level"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.space_level_label
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.space_layout_label != undefined && data.space_layout_label != null && data.space_layout_label.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.spaces"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.space_layout_label
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.space_orientation_label != undefined && data.space_orientation_label != null && data.space_orientation_label.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.orientation"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.space_orientation_label
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.pool_type_label != undefined && data.pool_type_label != null && data.pool_type_label.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.type"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.pool_type_label
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.pool_area_sqm != undefined && data.pool_area_sqm != null && data.pool_area_sqm.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.area"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        data.pool_area_sqm,
                                        "\xa0",
                                        t("unit.sqm")
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.bedroom_area_sqm != undefined && data.bedroom_area_sqm != null && data.bedroom_area_sqm.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.area"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        data.bedroom_area_sqm,
                                        "\xa0",
                                        t("unit.sqm")
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.min_depth != undefined && data.min_depth != null && data.min_depth.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.minDepth"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.min_depth
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.max_depth != undefined && data.max_depth != null && data.max_depth.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "col-md-12 fs-16",
                            children: [
                                t("space.maxDepth"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: data.max_depth
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        })
    });
};
/* harmony default export */ var partials_AttributesList = (AttributesList);

// EXTERNAL MODULE: ./components/templates/index/sections/BedroomsModal.tsx
var BedroomsModal = __webpack_require__(22715);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ExtendedSpaces.tsx

















var MAX_VISIBLE_FACILITIES = 4;
function facilitiesSummary(facilities) {
    if (!Checkers/* default.isValidArray */.Z.isValidArray(facilities)) {
        return null;
    }
    var visible = facilities.slice(0, MAX_VISIBLE_FACILITIES);
    var rest = facilities.length - visible.length;
    return visible.join(" \xb7 ") + (rest > 0 ? " \xb7 +" + rest + " more" : "");
}
function widthClassesForCount(count) {
    if (count === 1) {
        var cls = "col-md-12 col-sm-12 col-xs-12";
        return {
            master: cls,
            prePrePreLast: cls,
            prePreLast: cls,
            preLast: cls,
            last: cls
        };
    }
    if (count % 3 === 0) {
        var cls1 = "col-md-4 col-sm-4 col-xs-12";
        return {
            master: cls1,
            prePrePreLast: cls1,
            prePreLast: cls1,
            preLast: cls1,
            last: cls1
        };
    }
    if (count % 2 === 0) {
        var cls2 = "col-md-6 col-sm-6 col-xs-12";
        return {
            master: cls2,
            prePrePreLast: cls2,
            prePreLast: cls2,
            preLast: cls2,
            last: cls2
        };
    }
    if ((count + 1) % 3 === 0) {
        return {
            master: "col-md-6 col-sm-6 col-xs-12",
            prePrePreLast: "col-md-6 col-sm-6 col-xs-12",
            prePreLast: "col-md-4 col-sm-4 col-xs-12",
            preLast: "col-md-4 col-sm-4 col-xs-12",
            last: "col-md-4 col-sm-4 col-xs-12"
        };
    }
    if ((count + 2) % 3 === 0) {
        return {
            master: "col-md-4 col-sm-4 col-xs-12",
            prePrePreLast: "col-md-3 col-sm-6 col-xs-12",
            prePreLast: "col-md-3 col-sm-6 col-xs-12",
            preLast: "col-md-3 col-sm-6 col-xs-12",
            last: "col-md-3 col-sm-6 col-xs-12"
        };
    }
    var cls3 = "col-md-4 col-sm-4 col-xs-12";
    return {
        master: cls3,
        prePrePreLast: cls3,
        prePreLast: cls3,
        preLast: cls3,
        last: cls3
    };
}
function widthClassForIndex(index, count, classes) {
    var revindex = count - index;
    if (revindex === 1) return classes.last;
    if (revindex === 2) return classes.preLast;
    if (revindex === 3) return classes.prePreLast;
    if (revindex === 4) return classes.prePrePreLast;
    return classes.master;
}
function ExtendedSpaces(props) {
    var t = (0,i18n/* useT */.NT)();
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertyId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    });
    var ref = (0,react.useState)(false), areasLoaded = ref[0], setAreasLoaded = ref[1];
    var ref1 = (0,react.useState)(false), bedroomsLoaded = ref1[0], setBedroomsLoaded = ref1[1];
    (0,react.useEffect)(function() {
        var cancelled = false;
        setAreasLoaded(false);
        Promise.resolve(dispatch((0,actions/* fetchPropertySpaces */.PH)(propertyId))).catch(function() {
            return undefined;
        }).then(function() {
            if (!cancelled) setAreasLoaded(true);
        });
        return function() {
            cancelled = true;
        };
    }, [
        inViewport,
        propertyId
    ]);
    var componentLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["loading"];
    });
    var propertyPools = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["pools"];
    });
    var propertySpaces = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["spaces"];
    });
    var ref2 = (0,react.useState)("close"), modalState = ref2[0], setModalState = ref2[1];
    var modalData = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"];
    });
    var modalMedia = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["media"] : null;
    });
    var modalDataExtendend = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"] : null;
    });
    var modalContent = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["description"] : null;
    });
    var modalContentExtra = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["space_details"] : "";
    });
    var modalFeaturesList = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["features"] : null;
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var ref3 = (0,react.useState)(null), propertyBedrooms = ref3[0], setPropertyBedrooms = ref3[1];
    var bedroomsRequestIdRef = (0,react.useRef)(0);
    var isHotel = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHotel"];
    });
    var handleShow = function(type, area_id) {
        if (type == "poolModal") {
            dispatch((0,actions/* fetchPropertyPool */.Sr)(pageId, propertyId, area_id));
        } else if (type == "spaceModal") {
            dispatch((0,actions/* fetchPropertySpace */.I$)(pageId, propertyId, area_id));
        } else if (type == "bedroomsModal") {
        // dispatch<any>(fetchPropertyBedrooms(pageId, propertyId))
        }
        setModalState(type + (area_id != null ? area_id : ""));
    };
    var handleHide = function() {
        setModalState("close");
    };
    (0,react.useEffect)(function() {
        var requestId = ++bedroomsRequestIdRef.current;
        setBedroomsLoaded(false);
        Promise.resolve(dispatch((0,actions/* fetchPropertyBedrooms */.QC)(pageId, propertyId))).then(function(bedroomsData) {
            if (requestId !== bedroomsRequestIdRef.current) return;
            setPropertyBedrooms(bedroomsData);
            setBedroomsLoaded(true);
        }).catch(function() {
            if (requestId === bedroomsRequestIdRef.current) setBedroomsLoaded(true);
        });
    }, [
        pageId,
        propertyId
    ]);
    var validPools = Checkers/* default.isValidArray */.Z.isValidArray(propertyPools) ? propertyPools.filter(function(pool) {
        return pool.media != null;
    }) : [];
    var firstBedroomWithImage = !isHotel && Checkers/* default.isValidArray */.Z.isValidArray(propertyBedrooms) ? propertyBedrooms.find(function(bedroom) {
        return Checkers/* default.isValidArray */.Z.isValidArray(bedroom.media);
    }) : null;
    var validSpaces = Checkers/* default.isValidArray */.Z.isValidArray(propertySpaces) ? propertySpaces.filter(function(space) {
        return space.media != null;
    }) : [];
    var tiles = (0,_to_consumable_array/* default */.Z)(validPools.map(function(pool) {
        return {
            key: "pool" + pool.pool_id,
            title: pool.pool_title,
            imageSquare: pool.media.image_square_thumb,
            onClick: function() {
                return handleShow("poolModal", pool.pool_id);
            },
            modal: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                modalName: "poolModal" + pool.pool_id,
                className: "slide_right",
                Title: pool.pool_title,
                modalSize: "lg",
                loaderStatus: !modalData.valid,
                closeModal: function() {
                    handleHide();
                },
                show: modalState === "poolModal" + pool.pool_id,
                BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                    ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                images: modalMedia,
                                enableFancyBox: true,
                                enableAlbumRightModal: false
                            }, "pool-images-swiper"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                content: modalContent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                data: modalDataExtendend
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                featureList: modalFeaturesList
                            })
                        ]
                    })
                })
            }, 100)
        };
    })).concat((0,_to_consumable_array/* default */.Z)(firstBedroomWithImage != null ? [
        {
            key: "bedrooms",
            title: t("property.bedrooms"),
            imageSquare: firstBedroomWithImage.media[0].image_square_thumb,
            onClick: function() {
                return handleShow("bedroomsModal", null);
            },
            modal: /*#__PURE__*/ (0,jsx_runtime.jsx)(BedroomsModal/* default */.Z, {
                bedrooms: propertyBedrooms,
                pageId: pageId,
                propertyId: propertyId,
                show: modalState === "bedroomsModal",
                onClose: function() {
                    handleHide();
                }
            }, 100)
        }
    ] : []), (0,_to_consumable_array/* default */.Z)(validSpaces.map(function(space) {
        return {
            key: "space" + space.space_id,
            title: space.space_title,
            subtitle: facilitiesSummary(space.facilities),
            imageSquare: space.media.image_square_thumb,
            onClick: function() {
                return handleShow("spaceModal", space.space_id);
            },
            modal: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                modalName: "spaceModal" + space.space_id,
                className: "slide_right",
                Title: space.space_title,
                modalSize: "lg",
                loaderStatus: !modalData.valid,
                closeModal: function() {
                    handleHide();
                },
                show: modalState === "spaceModal" + space.space_id,
                BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                    ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                images: modalMedia,
                                enableFancyBox: true,
                                enableAlbumRightModal: false
                            }, "space-images-swiper"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                content: modalContent,
                                extraContent: modalContentExtra
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                data: modalDataExtendend
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                featureList: modalFeaturesList
                            })
                        ]
                    })
                })
            }, 100)
        };
    })));
    var widthClasses = widthClassesForCount(tiles.length);
    return componentLoading || !areasLoaded || !bedroomsLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-8 col-sm-6 col-md-4 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 70,
                    className: "col-12 col-sm-10 col-md-8 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 150,
                    className: "col-12 b-rad-lg"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !props.isHotel && tiles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "block-title m-t-40 hint-text no-margin",
                    children: t("property.spaces")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "m-t-5",
                    children: t("property.layout")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "pro_detail_spaces",
                    className: "p-b-65",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: tiles.map(function(tile, index) {
                                var widthClass = widthClassForIndex(index, tiles.length, widthClasses);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: widthClass + " text-center bg-success hover-push demo-story-block",
                                            onClick: tile.onClick,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hover-backdrop",
                                                    style: {
                                                        backgroundImage: "url(" + tile.imageSquare + ")"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hover-caption bottom-left bottom-right p-b-20",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "fs-16 text-white m-b-0",
                                                        children: tile.title
                                                    })
                                                })
                                            ]
                                        }),
                                        tile.modal
                                    ]
                                }, tile.key);
                            })
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/partials/spaces/SpacesMenu.tsx


function SpacesMenu(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.spaces.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "nav nav-tabs nav-tabs-fillup",
                role: "tablist",
                "data-init-reponsive-tabs": "dropdownfx",
                children: props.spaces.map(function(position, index) {
                    var this_position = position.tab;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: index == 0 ? "active" : null,
                            "data-bs-toggle": "tab",
                            href: "#",
                            "data-bs-target": "#" + this_position.tab_id,
                            style: {
                                color: "#626262"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "fw-normal fs-12 main-design-color",
                                children: this_position.title
                            })
                        })
                    }, this_position.tab_id.toString());
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-responsive-masonry/es/index.js + 2 modules
var react_responsive_masonry_es = __webpack_require__(2337);
;// CONCATENATED MODULE: ./components/templates/property/partials/spaces/SpacesTabContent.tsx





function SpacesTabContent(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tab-content bg-master-lightest-important pt-4",
        children: props.spaces.length > 0 && props.spaces.map(function(position, index) {
            var tab_pane_class = "tab-pane fade";
            tab_pane_class += index == 0 ? " show active" : "";
            var this_position = position.tab;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: this_position.tab_id,
                className: tab_pane_class,
                children: position.content.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                    columnsCountBreakPoints: {
                        576: 1,
                        768: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                        gutter: "30px",
                        options: {
                            columnWidth: 1
                        },
                        children: position.content.map(function(space) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "block-title p-b-15 text-black m-b-0",
                                        children: [
                                            space.space_title,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faChevronRight */._tD,
                                                className: "text-black m-l-10 fw-normal fs-11 align-baseline"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-elem mb-0",
                                        dangerouslySetInnerHTML: {
                                            __html: space.space_description
                                        }
                                    })
                                ]
                            }, space.space_id.toString());
                        })
                    })
                })
            }, this_position.tab_id.toString());
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/CompactSpaces.tsx












function CompactSpaces(props) {
    var t = (0,i18n/* useT */.NT)();
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config).inViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !inViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: myRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 30,
                        className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 42,
                        className: "col-8 col-sm-6 col-md-4 b-rad-md mb-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 70,
                        className: "col-12 col-sm-10 col-md-8 b-rad-md mb-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 150,
                        className: "col-12 b-rad-lg"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "block-title m-t-40 hint-text no-margin",
                        children: t("property.spaces")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "m-t-5",
                        children: t("property.layout")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row w-100 no-margin pt-4",
                        children: [
                            props.areaSqm != null && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.areaSqm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-auto ps-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "m-b-30 fs-14",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faHome */.J9Y,
                                                className: "text-master m-r-10",
                                                size: "2x"
                                            }),
                                            " ",
                                            props.areaSqm,
                                            t("unit.sqm"),
                                            ". (",
                                            Methods/* default.floatFormat */.Z.floatFormat(props.areaSqm * 10.764, 2),
                                            " ",
                                            t("unit.sqft"),
                                            ")"
                                        ]
                                    })
                                })
                            }),
                            props.areaOutdoorSqm != null && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.areaOutdoorSqm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-auto ps-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "fs-14 m-b-30",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faBenchTree */.JBK,
                                                className: "text-master m-r-10",
                                                size: "2x"
                                            }),
                                            " ",
                                            props.areaOutdoorSqm,
                                            t("unit.sqm"),
                                            ". (",
                                            Methods/* default.floatFormat */.Z.floatFormat(props.areaOutdoorSqm * 10.764, 2),
                                            " ",
                                            t("unit.sqft"),
                                            ")"
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    Checkers/* default.isValidArray */.Z.isValidArray(props.spaces) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 no-margin",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12 no-padding",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card card-transparent ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpacesMenu, {
                                        spaces: props.spaces
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpacesTabContent, {
                                        spaces: props.spaces
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/properties/partials/BedsArrangement.tsx





var BedsArrangement = function(param) {
    var data = param.data;
    var t = (0,i18n/* useT */.NT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "block-title p-b-15 text-black",
                    children: [
                        t("bedroom.beds"),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            className: "me-2",
                            icon: pro_solid_svg_icons/* faAngleRight */.yOZ
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "row m-b-20",
                    children: [
                        data.bedroom_beds_king != null && data.bedroom_beds_king != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.king"),
                                    ":\xa0",
                                    data.bedroom_beds_king
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_beds_queen != null && data.bedroom_beds_queen != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.queen"),
                                    ":\xa0",
                                    data.bedroom_beds_queen
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_beds_double != null && data.bedroom_beds_double != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.double"),
                                    ":\xa0",
                                    data.bedroom_beds_double
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_beds_single != null && data.bedroom_beds_single != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.single"),
                                    ":\xa0",
                                    data.bedroom_beds_single
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_beds_sofabed != null && data.bedroom_beds_sofabed != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.sofabed"),
                                    ":\xa0",
                                    data.bedroom_beds_sofabed
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_beds_murphy != null && data.bedroom_beds_murphy != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.murphy"),
                                    ":\xa0",
                                    data.bedroom_beds_murphy
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_bunk != null && data.bedroom_bunk != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.bunk"),
                                    ":\xa0",
                                    data.bedroom_bunk
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        data.bedroom_baby_cribs != null && data.bedroom_baby_cribs != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "col-md-6",
                                children: [
                                    t("bed.babyCrib"),
                                    ":\xa0",
                                    data.bedroom_baby_cribs
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var partials_BedsArrangement = (BedsArrangement);

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ExtendedCarouselSpaces.tsx

















function ExtendedCarouselSpaces(props) {
    var t = (0,i18n/* useT */.NT)();
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertyId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    });
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchPropertySpaces */.PH)(propertyId));
    }, [
        inViewport
    ]);
    var componentLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["loading"];
    });
    var propertyPools = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["pools"];
    });
    var propertySpaces = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["spaces"];
    });
    var propertyBedrooms = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["bedrooms"];
    });
    var ref = (0,react.useState)("close"), modalState = ref[0], setModalState = ref[1];
    var modalBedroomsData = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modalBedrooms"];
    });
    var modalData = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"];
    });
    var modalMedia = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["media"] : null;
    });
    var modalDataExtendend = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"] : null;
    });
    var modalContent = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["description"] : null;
    });
    var modalContentExtra = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["space_details"] : "";
    });
    var modalFeaturesList = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modal"]["valid"] ? state["singlePropertyData"]["modal"]["data"]["features"] : null;
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var handleShow = function(type, area_id) {
        if (type == "poolModal") {
            dispatch((0,actions/* fetchPropertyPool */.Sr)(pageId, propertyId, area_id));
        } else if (type == "spaceModal") {
            dispatch((0,actions/* fetchPropertySpace */.I$)(pageId, propertyId, area_id));
        } else if (type == "bedroomModal") {
            dispatch((0,actions/* fetchPropertyBedroomById */.mu)(pageId, propertyId, area_id));
        }
        setModalState(type + (area_id != null ? area_id : ""));
    };
    var handleHide = function() {
        setModalState("close");
    };
    var propertyBedroom = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modalSingleBedroom"];
    });
    var propertyBedroomData = propertyBedroom.hasOwnProperty("data") ? Checkers/* default.isValidArray */.Z.isValidArray(propertyBedroom.data) ? propertyBedroom.data[0] : propertyBedroom.data : null;
    var spacesComponent = [];
    if (propertyPools != null && propertyPools.length > 0) {
        propertyPools.map(function(pool) {
            if (pool.media == undefined || pool.media == null) {
                return;
            }
            var space = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center bg-success hover-push demo-story-block",
                        onClick: function() {
                            return handleShow("poolModal", pool.pool_id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-backdrop",
                                style: {
                                    backgroundImage: "url(" + (pool.media != undefined && pool.media != null ? pool.media.image_square_thumb : "") + ")"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-caption bottom-left bottom-right p-b-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "fs-16 text-white m-b-0",
                                    children: pool.pool_title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                        modalName: "poolModal" + pool.pool_id,
                        className: "slide_right",
                        Title: pool.pool_title,
                        modalSize: "lg",
                        loaderStatus: !modalData.valid,
                        closeModal: function() {
                            handleHide();
                        },
                        show: modalState === "poolModal" + pool.pool_id,
                        BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                            ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                        images: modalMedia,
                                        enableFancyBox: true,
                                        enableAlbumRightModal: false
                                    }, "pool-images-swiper"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                        content: modalContent
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                        data: modalDataExtendend
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                        featureList: modalFeaturesList
                                    })
                                ]
                            })
                        })
                    }, 100)
                ]
            });
            spacesComponent.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: space
            }));
        });
    }
    if (propertySpaces != null && propertySpaces != undefined && propertySpaces.length > 0) {
        propertySpaces.map(function(space) {
            if (space.media == undefined || space.media == null) {
                return;
            }
            var spaceItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center bg-success hover-push demo-story-block",
                        onClick: function() {
                            return handleShow("spaceModal", space.space_id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-backdrop",
                                style: {
                                    backgroundImage: "url(" + (space.media != undefined && space.media != null ? space.media.image_square_thumb : "") + ")"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-caption bottom-left bottom-right p-b-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "fs-16 text-white m-b-0",
                                    children: space.space_title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                        modalName: "spaceModal" + space.space_id,
                        className: "slide_right",
                        Title: space.space_title,
                        modalSize: "lg",
                        loaderStatus: !modalData.valid,
                        closeModal: function() {
                            handleHide();
                        },
                        show: modalState === "spaceModal" + space.space_id,
                        BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                            ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                        images: modalMedia,
                                        enableFancyBox: true,
                                        enableAlbumRightModal: false
                                    }, "space-images-swiper"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                        content: modalContent,
                                        extraContent: modalContentExtra
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                        data: modalDataExtendend
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                        featureList: modalFeaturesList
                                    })
                                ]
                            })
                        })
                    }, 100)
                ]
            });
            spacesComponent.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: spaceItem
            }));
        });
    }
    var bedroomsComponent = [];
    if (propertyBedrooms != null && propertyBedrooms != undefined && propertyBedrooms.length > 0) {
        propertyBedrooms.map(function(bedroom, i) {
            if (bedroom.media == undefined || bedroom.media == null) {
                return;
            }
            var bedroomItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center bg-success hover-push demo-story-block",
                        onClick: function() {
                            return handleShow("bedroomModal", bedroom.bedroom_id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-backdrop",
                                style: {
                                    backgroundImage: "url(" + (bedroom.media != undefined && bedroom.media != null ? bedroom.media.image_square_thumb : "") + ")"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-caption bottom-left bottom-right p-b-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "fs-16 text-white m-b-0",
                                    children: bedroom.bedroom_title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                        modalName: "bedroomModal" + bedroom.bedroom_id,
                        className: "slide_right",
                        Title: bedroom.bedroom_title,
                        modalSize: "lg",
                        loaderStatus: !propertyBedroom.valid,
                        closeModal: function() {
                            handleHide();
                        },
                        show: modalState === "bedroomModal" + bedroom.bedroom_id,
                        BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                            ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: propertyBedroomData != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        propertyBedroomData.hasOwnProperty("media") && Checkers/* default.isValidArray */.Z.isValidArray(propertyBedroomData.media) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                            images: propertyBedroomData.media,
                                            enableFancyBox: true,
                                            enableAlbumRightModal: false
                                        }, "bedroom-images-swiper") : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                            content: propertyBedroomData.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                            data: propertyBedroomData
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_BedsArrangement, {
                                            data: propertyBedroomData
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                            featureList: propertyBedroomData.features
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            })
                        })
                    }, 100)
                ]
            });
            bedroomsComponent.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: bedroomItem
            }));
        });
    }
    return componentLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 42,
                    className: "col-8 col-sm-6 col-md-4 b-rad-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 70,
                    className: "col-12 col-sm-10 col-md-8 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 150,
                    className: "col-12 b-rad-lg"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: propertyPools != null || propertySpaces != null || propertyBedrooms != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "block-title m-t-40 hint-text no-margin",
                            children: t("property.layout")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "m-t-5",
                            children: t("property.bedrooms")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pro_detail_spaces",
                            className: "p-b-65",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row padding-15",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                    imageSlider: false,
                                    htmlSlides: bedroomsComponent,
                                    paginationBulletsEnabled: false,
                                    slidesPerView: 3,
                                    slidesPerViewLg: 3,
                                    slidesPerViewMd: 3,
                                    slidesPerViewSm: 2,
                                    slidesPerViewXs: 1.4,
                                    spaceBetween: 20,
                                    enableLoop: false,
                                    galleryHeight: "auto",
                                    wrapperClassName: "d-navigation p-0 ",
                                    enableFancyBox: false,
                                    centeredSlides: false
                                }, "bedrooms-slider")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "m-t-5",
                            children: t("property.spaces")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pro_detail_spaces",
                            className: "p-b-65",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row padding-15",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                    imageSlider: false,
                                    htmlSlides: spacesComponent,
                                    paginationBulletsEnabled: false,
                                    slidesPerView: 3,
                                    slidesPerViewLg: 3,
                                    slidesPerViewMd: 3,
                                    slidesPerViewSm: 2,
                                    slidesPerViewXs: 1.4,
                                    spaceBetween: 20,
                                    enableLoop: false,
                                    galleryHeight: "auto",
                                    wrapperClassName: "d-navigation p-0 ",
                                    enableFancyBox: false,
                                    centeredSlides: false
                                }, "spaces-slider")
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/SpacesViewPort.tsx






function Spaces(props) {
    var areasLayoutSetting = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_layout");
    });
    return (props.areaSqm != null || props.areaOutdoorSqm != null || props.spaces.hasOwnProperty("tab_content") && props.spaces.tab_content.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "pro_detail_spaces",
        className: "pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row w-100 no-margin",
            children: areasLayoutSetting == "carousel" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendedCarouselSpaces, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: areasLayoutSetting == "thumbnails" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendedSpaces, {
                        isHotel: props.isHotel
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactSpaces, {
                        areaSqm: props.areaSqm,
                        areaOutdoorSqm: props.areaOutdoorSqm,
                        spaces: props.spaces
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ThemesViewPort.tsx






function Themes(props) {
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var viewPortResult = null;
    if (!inViewport) {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: myRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                className: "col-12 b-rad-md",
                height: 30
            })
        });
    } else {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row w-100 m-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12",
                children: props.themes.map(function(theme, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active",
                        children: [
                            Checkers/* default.isValidString */.Z.isValidString(theme.theme_fa_icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: theme.theme_fa_icon + " m-r-10"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-solid fa-hashtag m-r-10"
                            }),
                            theme.theme_title
                        ]
                    }, "property-themes-" + index);
                })
            })
        });
    }
    return Checkers/* default.isValidArray */.Z.isValidArray(props.themes) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: myRef,
        id: "pro_detail_themes",
        className: "pb-5",
        children: viewPortResult
    });
}

// EXTERNAL MODULE: ./node_modules/@react-aria/ssr/dist/module.js
var dist_module = __webpack_require__(78831);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/TermsViewPort.tsx




function TermsViewPort(props) {
    var t = (0,i18n/* useT */.NT)();
    var showDivHandler = function() {
        if (Checkers/* default.isValidArray */.Z.isValidArray(props.terms) && props.terms.length > 0 || Checkers/* default.isValidString */.Z.isValidString(props.terms)) {
            return true;
        }
        if (props.hasOwnProperty("descRules") && props.descRules.length > 0) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showDivHandler() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "pro_detail_desc",
                className: "pb-5",
                children: [
                    Checkers/* default.isValidArray */.Z.isValidArray(props.terms) && props.terms.length > 0 || Checkers/* default.isValidString */.Z.isValidString(props.terms) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "block-title m-t-40 hint-text no-margin",
                                children: t("property.policies")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "m-t-5",
                                children: t("property.policiesTitle")
                            }),
                            Checkers/* default.isValidArray */.Z.isValidArray(props.terms) && props.terms.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: props.terms.length > 0 && props.terms.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: item
                                        })
                                    });
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: Checkers/* default.isValidString */.Z.isValidString(props.terms) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: props.terms
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    props.hasOwnProperty("descRules") && props.descRules.length > 0 && props.terms != props.descRules ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-2",
                            dangerouslySetInnerHTML: {
                                __html: props.descRules
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./helpers/PropertyUnits.ts
var PropertyUnits = __webpack_require__(39227);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/PropertyHeadingDescViewPort.tsx












fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;


function PropertyHeading(props) {
    var ref = (0,react.useState)((0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    })), isPublicDomain = ref[0], setIsPublicDomain = ref[1];
    var classification = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["classification"];
    });
    var typeTitle = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["typeTitle"];
    });
    var ref1 = (0,react.useState)(0), publicDomain = ref1[0], setPublicDomain = ref1[1];
    var isHotel = props.details.system_type_id === 2 ? true : false;
    var isChain = props.hasOwnProperty("isChain") ? props.isChain : false;
    (0,react.useEffect)(function() {
        setPublicDomain(isPublicDomain);
    }, [
        isPublicDomain,
        setPublicDomain,
        classification
    ]);
    var _$config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, _$config, props).inViewport;
    var tUnits = (0,i18n/* useT */.NT)();
    var arrayHandler = function() {
        var array = [
            {
                key: "guests",
                value: props.details.capacity
            },
            {
                key: "bedrooms",
                value: props.details.bedrooms
            },
            {
                key: "bathrooms",
                value: props.details.bathrooms
            },
            {
                key: "pools",
                value: props.details.pools
            },
            {
                key: "jacuzzi",
                value: props.details.jacuzzi
            }, 
        ];
        if (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.details.property_area_sqm)) {
            array.push({
                key: "indoor_area",
                value: props.details.property_area_sqm + " m<sup>2</sup> indoor"
            });
        }
        if (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.details.property_area_outdoor_sqm)) {
            array.push({
                key: "outdoor_area",
                value: props.details.property_area_outdoor_sqm + " m<sup>2</sup> outdoor"
            });
        }
        return array;
    };
    var hotelArray = [
        {
            key: "typeTitle",
            value: typeTitle
        },
        {
            key: "classification",
            value: classification
        }, 
    ];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isExpanded = ref2[0], setExpanded = ref2[1];
    var getCollapseProps = (0,react_collapsed_esm/* default */.Z)({
        isExpanded: isExpanded
    }).getCollapseProps;
    var ref3 = (0,react.useState)(props.details.property_title), propertyTitle = ref3[0], setPropertyTitle = ref3[1];
    var alternative_title = props.details.alternative_title;
    (0,react.useEffect)(function() {
        if (alternative_title != undefined && publicDomain == 1) {
            if (alternative_title.length > 0) {
                setPropertyTitle(alternative_title);
            }
        }
    }, [
        publicDomain,
        setPropertyTitle,
        alternative_title
    ]);
    var viewPortResult = null;
    // if(!inViewport){
    //     viewPortResult =
    //         <>
    //             <Skeleton height={30} className="col-8 col-sm-6 col-md-4 b-rad-md mb-1" />
    //             <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
    //             <Skeleton height={30} className="col-12 col-sm-8 col-md-6 b-rad-md mb-1"/>
    //             <Skeleton height={150} className="col-12 b-rad-lg"/>
    //         </>
    //     ;
    // } else {
    viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (Checkers/* default.isValidString */.Z.isValidString(props.location.address) || Checkers/* default.isValidString */.Z.isValidString(props.location.address)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "block-title hint-text no-margin",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons/* faLocationDot */.opg,
                        className: "m-r-10"
                    }),
                    Checkers/* default.isValidString */.Z.isValidString(props.location.address) && props.location.address,
                    Checkers/* default.isValidString */.Z.isValidString(props.location.address) && ", " + props.location.city
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "bold m-t-5 m-b-30",
                children: propertyTitle
            }),
            isHotel === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: hotelArray.map(function(item, index, elements) {
                    if (Checkers/* default.isValidString */.Z.isValidString(item.value)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: item.key == "classification" ? pro_solid_svg_icons/* faStar */.Tab : item.key == "typeTitle" ? pro_solid_svg_icons/* faHotel */.Ht4 : null,
                                    className: "text-master"
                                }),
                                " ",
                                (0,PropertyUnits/* localizeUnits */.a)(item.value, tUnits),
                                elements[index + 1] != null && Checkers/* default.isValidString */.Z.isValidString(elements[index + 1].value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: " \xb7 "
                                }, "dot-" + index)
                            ]
                        }, item.key.toString());
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: !isChain && arrayHandler().map(function(item, index, elements) {
                    if (Checkers/* default.isValidString */.Z.isValidString(item.value)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: item.key == "guests" ? pro_solid_svg_icons/* faUsers */.FVb : item.key == "bedrooms" ? pro_solid_svg_icons/* faBed */.by_ : item.key == "bathrooms" ? pro_solid_svg_icons/* faShower */.ljI : item.key == "jacuzzi" ? pro_solid_svg_icons/* faHotTub */.Say : item.key == "indoor_area" ? pro_regular_svg_icons/* faArrowDownToSquare */.s6l : item.key == "outdoor_area" ? pro_regular_svg_icons/* faArrowUpFromSquare */.Nop : pro_regular_svg_icons/* faSwimmingPool */.eiT,
                                    className: "text-master"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: (0,PropertyUnits/* localizeUnits */.a)(item.value, tUnits)
                                    }
                                }),
                                index < elements.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: " \xb7 "
                                }, "dot-" + index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }, item.key.toString());
                    }
                })
            })
        ]
    });
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: myRef,
        id: "pro_detail_desc",
        className: "row full-width no-margin",
        children: viewPortResult
    });
}

// EXTERNAL MODULE: ./components/templates/property/partials/modals/ModalPois.tsx
var ModalPois = __webpack_require__(70263);
// EXTERNAL MODULE: ./components/templates/articles/ArticleCategoriesContainer.tsx
var ArticleCategoriesContainer = __webpack_require__(8202);
// EXTERNAL MODULE: ./hooks/useApiHook.tsx
var useApiHook = __webpack_require__(1185);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ExperiencesDestination.tsx







var ExperiencesDestination = function(param) {
    var experiences = param.experiences, app = param.app, app_data = param.app_data, builder = param.builder;
    var isPublicDomain = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean(state["appSettings"]["isPublicDomain"]);
    });
    var epxperiencesViewType = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_experiences_view_type");
    });
    var experiencesSubtitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_experiences_subtitle");
    });
    var experiencesShowCategories = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_experiences_show_categories"));
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    // const experiencesTest = fetchHomepageExperiencesCategoriesData(redis, pageId)
    var experiensesGenericWidget = (0,useApiHook/* useApiGet */.g)("/api/lodge/frontend/get/experiences/category/content", "page_id=" + pageId + "&experience_category_id=generic", false);
    var collectionItemsBtnLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_btn_label");
    });
    var isDesktop = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isPublicDomain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: experiencesShowCategories && !experiensesGenericWidget.loading && experiensesGenericWidget.data != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                    app_data: app_data,
                    app: app,
                    builder: builder,
                    type: "experiences",
                    content: experiensesGenericWidget.data,
                    isDesktop: isDesktop,
                    articlesCategories: null,
                    categoryIdInhrerited: "generic",
                    includeJumbotron: false,
                    includeTitle: true,
                    itemWrapperClassName: "d-flex col-12 col-sm-6 col-md-4 col-lg-4",
                    itemClassName: "experience-design-box",
                    showAllLabel: collectionItemsBtnLabel,
                    titleClassName: "d-block text-left ",
                    paddingTopClassName: "pt-5",
                    articlesLimit: 3
                }, "exp-categories-content-container")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: experiences != null && experiences.length > 0 ? experiences.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                app_data: app_data,
                                app: app,
                                builder: builder,
                                type: "experiences",
                                content: item,
                                isDesktop: true,
                                articlesCategories: null,
                                categoryIdInhrerited: item.id,
                                includeJumbotron: false,
                                includeTitle: !item.hide_title,
                                inheritedViewType: epxperiencesViewType,
                                itemClassName: "experience-design-box",
                                itemWrapperClassName: "d-flex col-12 col-sm-6 col-md-4 col-lg-4",
                                titleClassName: "justify-content-left text-left d-block ",
                                subtitleInherited: experiencesSubtitle,
                                paddingTopClassName: "",
                                viewMoreBtnStyle: "secondary",
                                articlesLimit: 3
                            }, index)
                        })
                    }, "fragment" + index);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/RelatedProperties.tsx








var Properties = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1611), __webpack_require__.e(357)]).then(__webpack_require__.bind(__webpack_require__, 59533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59533)
            ];
        }
    },
    suspense: true
});
var RelatedProperties = function(param) {
    var propertyId = param.propertyId, app = param.app, app_data = param.app_data, builder = param.builder, _slidesPerViewDesktop = param.slidesPerViewDesktop, slidesPerViewDesktop = _slidesPerViewDesktop === void 0 ? 2.5 : _slidesPerViewDesktop, _isHotel = param.isHotel, isHotel = _isHotel === void 0 ? false : _isHotel, _isChain = param.isChain, isChain = _isChain === void 0 ? false : _isChain;
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var relatedPropertiesViewType = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_view_type");
    });
    var relatedPropertiesLimit = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_limit");
    });
    var sectionTitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_title");
    });
    var sectionSubtitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_subtitle");
    });
    var propertiesData = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesData"];
    });
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var isTablet = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isTablet"];
    });
    var propertiesFetchHandler = function() {
        var params = cloneDeep_default()(propertiesParams);
        params.limit = relatedPropertiesLimit;
        params.mode = "related";
        dispatch((0,actions/* fetchPropertiesAction */.SH)(params));
    };
    var relatedPropertiesHandler = function() {
        var itemsToShow = [];
        if (propertiesData.properties != undefined) {
            for(var i = 0; i < propertiesData.properties.length; i++){
                var propertyItem = propertiesData.properties[i];
                var itemToShow = {
                    id: propertyItem.property_id,
                    title: propertyItem.property_title,
                    image: propertyItem.featured_images[0],
                    loggiaUrl: propertyItem.sourcePath,
                    urlSlug: propertyItem.sourcePath,
                    redirect_url: propertyItem.sourcePath
                };
                itemsToShow.push(itemToShow);
            }
        }
        return itemsToShow;
    };
    var itemsToShow = relatedPropertiesHandler();
    (0,react.useEffect)(function() {
        propertiesFetchHandler();
    }, []);
    // {
    //     "id": 2015,
    //     "show_in_different_page": true,
    //     "redirect_url": null,
    //     "title": "Curated Itineraries",
    //     "subtitle": "Personalised Itineraries & Luxury Travel Experiences in Greece",
    //     "urlSlug": "curated_Itineraries",
    //     "loggiaUrl": "/curated_Itineraries",
    //     "has_description": "1",
    //     "body": "<p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">We are far more than a Villa agency; we are a travel design agency that develops handcrafted itineraries and luxury travel experiences in Greece.</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">We believe that travel is inherently a life-altering experience, so we provide the</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.2px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">opportunities to our guests to explore Greece in an authentic and meaningful way,</span><font size=\"3\">&nbsp;</font></span><span style=\"font-size: 14px; font-family: Arial, sans-serif;\">discovering the destination through the eyes of a local expert.</span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\"><br></span></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">Fascinating culture, unique ancient sites, diverse picture-perfect landscapes, olive groves, wine routes and a culinary heritage rich in flavours and aromas. We invite you to explore Greece in an authentic and meaningful way, discovering the destination through the eyes of a local expert. Enjoy Greece’s captivating history and scenery with custom made private tours, activities and experiences.</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif; font-size: 14px;\">&nbsp;</span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">Throughout the travel design process, we always focus on putting relationships</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.2px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">first. Our collaborative, high-touch approach allows us to work hand-in-hand with</span><font size=\"3\">&nbsp;</font></span><span style=\"font-size: 14px; font-family: Arial, sans-serif;\">our clients, personalise their itinerary, design a flawless trip plan and craft meaningful travel experiences based on their lifestyle. This is what we strive for at All Greek Villas; to create the most memorable, most authentic, and most luxurious travel experience possible for you!</span></p>",
    //     "metaTitle": "We create the most luxurious travel experience in Greece",
    //     "metaDesc": "All Greek Villas is a travel design agency that develops handcrafted itineraries and luxury travel experiences all over Greece.",
    //     "metaKeywords": "greek luxurious travel, luxurious travel in greece, greek luxury travel, luxury travel services, luxury concierge services, concierge in Greece, best travel Greece, vip villas, top greek villas, travel experiences in Greece",
    //     "image": "https://cdn.loggia.gr/lodgeContent/61fd913c1ffd09dc183d973da2c7c95a_thumb.jpg",
    //     "description": ""
    // }
    // useEffect( () => {
    //     dispatch<any>(fetchPropertiesAction(propertiesParams, null))
    // }, [propertiesParams])
    // useEffect( () => {
    //
    //     // dispatch<any>(fetchPropertiesAction(propertiesParams, null))
    //
    //     console.log("relatedProperties", relatedPropertiesViewType, relatedPropertiesLimit, propertyId)
    //
    //     console.log("relatedProperties", propertiesParams)
    //
    //     console.log("relatedProperties", 'relatedPropertiesLimit', relatedPropertiesLimit)
    // })
    var useSwiperHandler = function() {
        if (isMobile || isTablet) {
            if (isMobile) {
                return itemsToShow.length > 1;
            } else if (isTablet) {
                return itemsToShow.length > 2;
            } else {
                return itemsToShow.length > 3;
            }
        } else {
            return true;
        }
    };
    var useSwiper = useSwiperHandler();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: itemsToShow != undefined && Checkers/* default.isValidArray */.Z.isValidArray(itemsToShow) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "p-b-100 properties-related",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container p-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " pb-4 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "undefined p-l-0 p-r-0 bg-master-lightest",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center w-100 m-0 justify-content-left text-left d-block ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 col-sm-10 text-center d-flex flex-column justify-content-left text-left d-block ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ",
                                                children: sectionSubtitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: " mt-1 fw-normal m-b-0 justify-content-left text-left d-block ",
                                                children: sectionTitle
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Properties, {
                                app: app,
                                app_data: app_data,
                                builder: builder,
                                propertiesParams: propertiesParams,
                                properties_count: null,
                                designMode: app.designMode,
                                searchbarRadius: app.searchbarRadius,
                                searchbarShadow: app.searchbarShadow,
                                bookingSearchbarWithBedrooms: app.bookingSearchbarWithBedrooms,
                                googleMapShow: false,
                                googleMapApiKey: app.googleMapsApiKey,
                                propertiesFilters: null,
                                destinationId: null,
                                showBookingBar: false,
                                showFiltersBar: false,
                                thumbClassInherited: useSwiper ? "col-12 col-sm-12 col-md-12 mb-3 p-l-0 p-r-0" : "col-12 col-sm-6 col-md-4 mb-3 p-l-0 p-r-0",
                                jumbotronTextAlign: "text-left",
                                propertiesContainerExtraClass: "",
                                showTotalPropertiesCount: false,
                                useSwipper: useSwiper,
                                slidesPerViewDesktop: slidesPerViewDesktop,
                                isRelatedSection: true,
                                isHotel: isHotel,
                                isChain: isChain
                            }, "properties-swipper-wraper")
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};

;// CONCATENATED MODULE: ./components/templates/property/content/columned/right/HighlightsViewPort.tsx




fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;






function Highlights(props) {
    var t = (0,i18n/* useT */.NT)();
    var _$config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, _$config, props).inViewport;
    var viewPortResult = null;
    if (!inViewport) {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: myRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-12 col-sm-6 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-12 col-sm-6 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-12 col-sm-6 b-rad-md mb-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    height: 30,
                    className: "col-12 col-sm-6 b-rad-md mb-1"
                })
            ]
        });
    } else {
        if (Checkers/* default.isValidArray */.Z.isValidArray(props.highlights)) {
            viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-0",
                        children: t("property.whyGuestsLoveIt")
                    }),
                    props.highlights.map(function(highlight) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-sm-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "fs-18",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faCheck */.LEp,
                                        className: "text-master m-r-10",
                                        size: "1x"
                                    }),
                                    highlight.tag_title
                                ]
                            })
                        }, highlight.tag_id.toString());
                    })
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: viewPortResult != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: myRef,
            id: "prop_highlights",
            className: "row full-width no-margin pb-5",
            children: viewPortResult
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/MediaSection.tsx



var MediaSection = function(param) {
    var factsheetDocument = param.factsheetDocument, threesixtyTour = param.threesixtyTour;
    var t = (0,i18n/* useT */.NT)();
    var hasThreesixtyTour = Checkers/* default.isValidString */.Z.isValidString(threesixtyTour) && threesixtyTour != "0";
    var hasFactsheet = Checkers/* default.isValidString */.Z.isValidString(factsheetDocument);
    if (!hasThreesixtyTour && !hasFactsheet) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "pro_detail_factsheets",
            className: "row full-width no-margin pb-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    Checkers/* default.isValidString */.Z.isValidString(threesixtyTour) && threesixtyTour != "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: threesixtyTour,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "text-master",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a",
                                            style: {
                                                width: "55px",
                                                height: "55px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa fa-regular fa-panorama fa-2x hint-text"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "chat-status available"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inline m-l-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "hint-text m-t-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                        children: [
                                                            "360",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                children: "o"
                                                            }),
                                                            " ",
                                                            t("property.virtualTour")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "btn-link",
                                                        children: t("property.walkThrough")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    Checkers/* default.isValidString */.Z.isValidString(factsheetDocument) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: factsheetDocument,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "text-master",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a",
                                            style: {
                                                width: "55px",
                                                height: "55px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa fa-duotone fa-file-pdf fa-2x hint-text"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "chat-status available"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inline m-l-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "hint-text m-t-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("property.factSheet")
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "btn-link",
                                                        children: t("property.downloadPdf")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(57093);
// EXTERNAL MODULE: ./components/templates/index/BookingSearchBar.tsx + 2 modules
var BookingSearchBar = __webpack_require__(83074);
// EXTERNAL MODULE: ./components/templates/properties/panel/Gallery.tsx
var Gallery = __webpack_require__(96491);
// EXTERNAL MODULE: ./components/templates/properties/panel/PanelBody.tsx + 2 modules
var PanelBody = __webpack_require__(79075);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/BedroomCard.tsx




function BedroomCard(props) {
    (0,react.useEffect)(function() {
        if (document !== undefined) {
            var dynamicBullets = document.querySelectorAll(".swiper-pagination-bullets-dynamic");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                for(var _iterator = dynamicBullets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var dynamicBullet = _step.value;
                    dynamicBullet.style.display = "flex";
                    dynamicBullet.style.paddingBottom = ".2rem";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var nextButtons = document.querySelectorAll(".swiper-custom-next");
            if (nextButtons) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    for(var _iterator1 = nextButtons[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var nextButton = _step1.value;
                        nextButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
            var prevButtons = document.querySelectorAll(".swiper-custom-prev");
            if (nextButtons) {
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    for(var _iterator2 = prevButtons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var prevButton = _step2.value;
                        prevButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: props.handleShow,
                    className: "cursor-pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery/* default */.Z, {
                        property_id: props.bedroom_id,
                        images: props.images,
                        captions: props.captions,
                        isHotel: true
                    }, "thumbs-gallery-swiper-" + props.bedroom_id)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelBody/* default */.Z, {
                        handleShow: props.handleShow,
                        property_id: props.bedroom_id,
                        property_title: props.bedroom_title,
                        bedrooms: props.bedrooms,
                        complexCount: props.complexCount,
                        bodyHrefClass: "mt-auto",
                        property_moto: props.description,
                        isHotel: true,
                        bedroom_prices: props.prices,
                        hideBookingActions: props.hideBookingActions,
                        property_location: props.locationLabel
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/properties/partials/BedroomsContentWrapper.tsx












var BedroomsContentWrapper = function(param) {
    var data = param.data;
    var propertyId = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(state["propertiesParams"]["property_id"]) ? state["propertiesParams"]["property_id"] : state["propertiesParams"]["property_id"].substring(0, state["propertiesParams"]["property_id"].indexOf("?"));
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(data.bedroom_id), selectedBedroomId = ref[0], setSelectedBedroomId = ref[1];
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchPropertyBedroomById */.mu)(pageId, propertyId, selectedBedroomId));
    }, []);
    var fetchBedroomData = function(bedroomId) {
        setSelectedBedroomId(bedroomId);
        dispatch((0,actions/* fetchPropertyBedroomById */.mu)(pageId, propertyId, bedroomId));
    };
    var propertyBedroom = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["modalSingleBedroom"];
    });
    var propertyBedroomData = propertyBedroom.hasOwnProperty("data") ? Checkers/* default.isValidArray */.Z.isValidArray(propertyBedroom.data) ? propertyBedroom.data[0] : propertyBedroom.hasOwnProperty("data") ? propertyBedroom.data : null : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row w-100 no-margin",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-md-12 no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "panel panel-transparent m-b-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: data.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "nav-tabs-header nav-tabs-linetriangle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "nav nav-tabs nav-tabs-linetriangle",
                                        role: "tablist",
                                        style: {
                                            width: "auto",
                                            whiteSpace: "nowrap",
                                            display: "inline-block"
                                        },
                                        "data-init-reponsive-tabs": "dropdownfx",
                                        children: Checkers/* default.isValidArray */.Z.isValidArray(data) && data.map(function(bedroom, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "fs-12 " + (i == 0 ? "active" : ""),
                                                        "data-toggle": "tab",
                                                        href: "#slide" + bedroom.bedroom_id,
                                                        "data-bs-toggle": "tab",
                                                        onClick: function() {
                                                            return fetchBedroomData(bedroom.bedroom_id);
                                                        },
                                                        "data-bs-target": "#slide" + bedroom.bedroom_id,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: bedroom.bedroom_title
                                                        })
                                                    })
                                                })
                                            });
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: propertyBedroom.valid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: propertyBedroomData != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            propertyBedroomData.hasOwnProperty("media") && Checkers/* default.isValidArray */.Z.isValidArray(propertyBedroomData.media) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                                                images: propertyBedroomData.media,
                                                enableFancyBox: true,
                                                enableAlbumRightModal: false
                                            }, "bedroom-image-swiper") : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SImpleContent, {
                                                content: propertyBedroomData.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_AttributesList, {
                                                data: propertyBedroomData
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_BedsArrangement, {
                                                data: propertyBedroomData
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FeaturesList, {
                                                featureList: propertyBedroomData.features
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                height: 340,
                                                className: "col-12 b-rad-lg d-block"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                height: 27,
                                                className: "col-12 b-rad-lg d-block"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                height: 27,
                                                className: "col-12 b-rad-lg d-block"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var partials_BedroomsContentWrapper = (BedroomsContentWrapper);

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/BedroomData.tsx







var BedroomData = function(props) {
    var ref = (0,react.useState)("close"), modalState = ref[0], setModalState = ref[1];
    var handleShow = function(type, bedroomId) {
        if (type === "bedroomModal") {
            var foundBedroom = props.bedroom.bedroom_id === bedroomId;
            if (foundBedroom) {
                setModalState(type + (bedroomId != null ? bedroomId : ""));
            }
        }
    };
    var handleHide = function() {
        setModalState("close");
    };
    var stripHtml = function(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
    };
    var media = props.bedroom.media;
    var imagesArray = [];
    if (Checkers/* default.isValidArray */.Z.isValidArray(media)) {
        for(var i = 0; i < media.length; i++){
            imagesArray.push(media[i].image);
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Properties Properties-Thumb Properties-Border Properties-Shadow flex-grow-1 mb-3 property-room-types",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BedroomCard, {
                    bedroom: props.bedroom,
                    bedroom_id: props.bedroom.bedroom_id,
                    bedroom_title: props.bedroom.bedroom_title,
                    bedrooms: props.bedroom.capacity_max,
                    description: stripHtml(props.bedroom.description),
                    images: imagesArray,
                    handleShow: function() {
                        return handleShow("bedroomModal", props.bedroom.bedroom_id);
                    },
                    isHotel: true,
                    prices: props.prices,
                    galleryRef: props.galleryRef,
                    galleryHeight: props.galleryHeight,
                    hideBookingActions: props.hideBookingActions,
                    locationLabel: props.locationLabel
                })
            }),
            props.bedroom && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                modalName: "bedroomModal" + props.bedroom.bedroom_id,
                className: "slide_right",
                Title: props.bedroom.bedroom_title,
                modalSize: "lg",
                loaderStatus: false,
                closeModal: function() {
                    handleHide();
                },
                show: modalState === "bedroomModal" + props.bedroom.bedroom_id,
                BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                    ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_BedroomsContentWrapper, {
                            data: props.bedroom
                        })
                    })
                })
            }, 100)
        ]
    });
};
/* harmony default export */ var left_BedroomData = (BedroomData);

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/BedroomsView.tsx















function BedroomsView(props) {
    var t = (0,i18n/* useT */.NT)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var sectionBackgroundColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_featured_properties_section_color");
    });
    var ref = (0,react.useState)(null), bookingBedrooms = ref[0], setBookingBedrooms = ref[1];
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var bedroomPricing = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bedroomPricing"];
    });
    var triggerSearh = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["searchTrigger"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var adults = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["kids"] + state["propertiesParams"]["infants"];
    });
    var propertyId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    });
    (0,react.useEffect)(function() {
        var cancelled = false;
        setBookingBedrooms(null);
        (0,client/* getPropertyBookingBedrooms */.EC)(propertyId, "is_booking=1&exclude_parking=1").then(function(data) {
            if (cancelled) return;
            var bedrooms = Checkers/* default.isValidArray */.Z.isValidArray(data === null || data === void 0 ? void 0 : data.bedrooms) ? data.bedrooms : [];
            setBookingBedrooms(bedrooms.filter(function(bedroom) {
                return Checkers/* default.isValidArray */.Z.isValidArray(bedroom.media) && bedroom.media.some(function(m) {
                    return Checkers/* default.isValidString */.Z.isValidString(m === null || m === void 0 ? void 0 : m.image);
                });
            }));
            dispatch({
                type: "updateBookingBedrooms",
                data: bedrooms
            });
        }).catch(function() {
            if (!cancelled) setBookingBedrooms([]);
        });
        return function() {
            cancelled = true;
        };
    }, [
        propertyId
    ]);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch((0,actions/* fetchBedroomPricesAction */.DE)(pageId, propertyId, checkin, checkout, adults, kids))
                            ];
                        case 1:
                            _state.sent();
                            dispatch((0,actions/* setSearchSpinner */.jo)(false));
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        triggerSearh
    ]);
    var hasSectionBackground = Checkers/* default.isHexColor */.Z.isHexColor(sectionBackgroundColor);
    var centerTwoItems = Checkers/* default.isValidArray */.Z.isValidArray(bookingBedrooms) && bookingBedrooms.length === 2;
    if (bookingBedrooms != null && bookingBedrooms.length === 0) {
        return null;
    }
    if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.isManager)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                bookingBedrooms && Checkers/* default.isValidArray */.Z.isValidArray(bookingBedrooms) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ",
                            children: t("property.roomTypesIntro")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "pb-4 mt-1 fw-normal",
                            children: t("property.roomTypes")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "SearchBar-Form__column row justify-content-end bg-white no-margin p-2 w-100 d-flex border-radius-10 shadow position-relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSearchBar["default"], {
                                containerClass: "container-fluid",
                                padding: 10,
                                isManager: true,
                                noShadow: true,
                                sliderSearchBar: true,
                                sliderSearchBarFullWidth: false,
                                bookingSearchbarWithBedrooms: props.bookingBedrooms,
                                isHomePage: false,
                                isHotel: props.isHotel ? props.isHotel : false
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 75,
                        className: "col-12 b-rad-lg d-block"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-10 mt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: bookingBedrooms && Checkers/* default.isValidArray */.Z.isValidArray(bookingBedrooms) ? bookingBedrooms.map(function(bedroom, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4 col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(left_BedroomData, {
                                    bedroom: bedroom,
                                    prices: bedroomPricing
                                })
                            }, key);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 340,
                                        className: "col-12 b-rad-lg d-block"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        className: "col-12 b-rad-lg d-block"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        className: "col-12 b-rad-lg d-block"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "properties-related p-t-50 p-b-50" + (hasSectionBackground ? " has-section-background" : "") + (centerTwoItems ? " center-two-items" : ""),
        style: hasSectionBackground ? {
            background: sectionBackgroundColor,
            boxShadow: "0 0 0 100vmax ".concat(sectionBackgroundColor),
            clipPath: "inset(0 -100vmax)"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: props.isHotel ? "" : "container",
            children: [
                bookingBedrooms && Checkers/* default.isValidArray */.Z.isValidArray(bookingBedrooms) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "block-title m-t-40 hint-text no-margin d-block" + (centerTwoItems ? " text-center" : " justify-content-left text-left") + (hasSectionBackground ? " text-light-color" : ""),
                            children: t("property.roomTypesIntro")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "pb-4 mt-1 fw-normal" + (centerTwoItems ? " text-center" : "") + (hasSectionBackground ? " text-light-color" : ""),
                            children: t("property.roomTypes")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 75,
                        className: "col-12 b-rad-lg d-block"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-10 mt-4",
                    children: bookingBedrooms && Checkers/* default.isValidArray */.Z.isValidArray(bookingBedrooms) ? bookingBedrooms.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
                        imageSlider: false,
                        htmlSlides: bookingBedrooms.map(function(bedroom, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(left_BedroomData, {
                                    bedroom: bedroom,
                                    prices: bedroomPricing,
                                    hideBookingActions: true,
                                    locationLabel: props.locationLabel
                                })
                            }, key);
                        }),
                        paginationBulletsEnabled: false,
                        slidesPerView: 3,
                        slidesPerViewLg: 3,
                        slidesPerViewMd: 3,
                        slidesPerViewSm: 2,
                        slidesPerViewXs: 1,
                        spaceBetween: 20,
                        enableLoop: false,
                        galleryHeight: "auto",
                        wrapperClassName: "d-navigation p-0",
                        enableFancyBox: false,
                        centeredSlides: false
                    }, "room-types-swiper") : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: bookingBedrooms.map(function(bedroom, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(left_BedroomData, {
                                    bedroom: bedroom,
                                    prices: bedroomPricing,
                                    hideBookingActions: true,
                                    locationLabel: props.locationLabel
                                })
                            }, key);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 340,
                                    className: "col-12 b-rad-lg d-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 27,
                                    className: "col-12 b-rad-lg d-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 27,
                                    className: "col-12 b-rad-lg d-block"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/templates/properties/partials/Thumbs.tsx
var Thumbs = __webpack_require__(63361);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/ChainPropertyData.tsx











function ChainPropertyData(props) {
    var t = (0,i18n/* useT */.NT)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var singlePropertyData = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["propertyData"];
    });
    var chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null;
    var isHotel = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHotel"];
    });
    var ref = (0,react.useState)(false), initialFetch = ref[0], setInitialFetch = ref[1];
    var propertiesWithChain = (0,es/* useSelector */.v9)(function(state) {
        return state["propertieswithChainData"]["propertiesWithChain"];
    });
    var propertyId = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(state["propertiesParams"]["property_id"]) ? state["propertiesParams"]["property_id"] : state["propertiesParams"]["property_id"].substring(0, state["propertiesParams"]["property_id"].indexOf("?"));
    });
    var ref1 = (0,react.useState)(null), infoWindowState = ref1[0], setInfoWindowState = ref1[1];
    var updateInfoWindowState = (0,react.useCallback)(function(state) {
        setInfoWindowState(function() {
            return state;
        });
    }, []);
    var centerObj = {};
    var property_id = 0;
    var prices = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["propertiesPricing"];
    });
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var adults = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["kids"] + state["propertiesParams"]["infants"];
    });
    var triggerSearh = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["searchTrigger"];
    });
    (0,react.useEffect)(function() {
        if (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(chainId)) {
            dispatch((0,actions/* fetchPropertiesWithChainAction */.Kl)(chainId));
        }
    }, [
        chainId
    ]);
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,actions/* fetchPropertiesPricesAction */.ZM)(propertiesWithChain, pageId, checkin, checkout, adults, kids, true, 1))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,actions/* setSearchSpinner */.jo)(false));
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var initialFetchHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!initialFetch && propertiesWithChain != undefined)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchData()
                        ];
                    case 1:
                        _state.sent();
                        setInitialFetch(true);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function initialFetchHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchData();
    }, [
        triggerSearh
    ]);
    (0,react.useEffect)(function() {
        if (!initialFetch && propertiesWithChain != undefined) {
            initialFetchHandler();
        }
    }, [
        propertiesWithChain
    ]);
    var ref2 = (0,react.useState)(property_id), previousProperty = ref2[0], setPreviousProperty = ref2[1];
    var ref3 = (0,react.useState)(centerObj), relocatedCenter = ref3[0], setRelocatedCenter = ref3[1];
    var changeMarker = (0,react.useCallback)(function(lat, lng, property_id) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        centerObj = {};
        if (Checkers/* default.isValidNumber */.Z.isValidNumber(lat) && Checkers/* default.isValidNumber */.Z.isValidNumber(lng)) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            centerObj = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };
        }
        var thisChild = document.getElementById("property_marker_" + property_id);
        var prevChild = document.getElementById("property_marker_" + previousProperty);
        if (thisChild) {
            thisChild.parentElement.style.zIndex = "1";
        }
        if (prevChild) {
            prevChild.parentElement.style.zIndex = "0";
        }
        setRelocatedCenter(function() {
            return centerObj;
        });
        setPreviousProperty(property_id);
    }, [
        relocatedCenter,
        previousProperty
    ]);
    var changeMarkerOnHover = function(lat, lng, property_id) {
        if (infoWindowState == null) {
            changeMarker(lat, lng, property_id);
        }
    };
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchSinglePropertyData */.pH)(propertyId));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.isChain && propertiesWithChain ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ",
                        children: t("property.groupIntro")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "pb-4 mt-1 fw-normal",
                        children: t("property.groupOfProperties")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "booking-search-bar",
                        className: "SearchBar-Form__column row justify-content-end bg-white no-margin p-2 w-100 d-flex border-radius-10 shadow position-relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSearchBar["default"], {
                            containerClass: "container-fluid",
                            padding: 10,
                            isManager: true,
                            noShadow: true,
                            sliderSearchBar: true,
                            sliderSearchBarFullWidth: false,
                            isNotForList: true,
                            //  searchbarThemeColor={app.searchbarThemeColor}
                            //  rgbaDesignColor={props.rgbaDesignColor}
                            //  searchbarRadius={props.searchbarRadius}
                            //  searchbarShadow={props.searchbarShadow}
                            // bookingSearchbarWithBedrooms={props.bookingBedrooms}
                            isHomePage: false,
                            isHotel: true
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 75,
                        className: "col-12 b-rad-lg d-block"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: propertiesWithChain ? propertiesWithChain.properties.map(function(b) {
                        var ref;
                        var propertyPrice = ((ref = prices === null || prices === void 0 ? void 0 : prices.find(function(p) {
                            return p.propertyId === b.property_id;
                        })) === null || ref === void 0 ? void 0 : ref.price) || 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-4 col-md-4 pb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbs["default"], {
                                property_id: b.property_id,
                                property_title: b.property_title,
                                property_moto: b.moto,
                                images: b.featured_images,
                                captions: b.captions,
                                changeMarkerOnHover: changeMarkerOnHover,
                                updateInfoWindowState: updateInfoWindowState,
                                // sourcePath={b.sourcePath}
                                minimumPrice: propertyPrice,
                                average_price: b.average_price,
                                capacity: b.capacity,
                                bedrooms: b.bedrooms,
                                hidePrices: b.hide_prices,
                                hasOpenCalendar: b.has_open_calendar,
                                inquiriesActive: b.inquiries_active,
                                tags: b.tags,
                                system_type_id: b.system_type_id,
                                classification: b.classification,
                                propertyType: b.type,
                                isHotel: false,
                                isChain: props.isChain,
                                isNotForList: true
                            })
                        }, b.property_id.toString());
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 340,
                                    className: "col-12 b-rad-lg d-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 27,
                                    className: "col-12 b-rad-lg d-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 27,
                                    className: "col-12 b-rad-lg d-block"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/LegalLicenseViewPort.tsx




var LegalLicenseViewPort = function(props) {
    var t = (0,i18n/* useT */.NT)();
    var details = props.details;
    var propertyLegalLicense = details.hasOwnProperty("property_legal_license") ? details.property_legal_license : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Checkers/* default.isValidString */.Z.isValidString(propertyLegalLicense) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row w-100 m-0 mb-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa-solid fa-file-certificate m-r-10"
                        }),
                        t("property.registrationNumber", {
                            number: propertyLegalLicense
                        })
                    ]
                }, "property-legal-license")
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};
/* harmony default export */ var left_LegalLicenseViewPort = (LegalLicenseViewPort);

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/B2BDescViewPort.tsx





fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;


function B2BDescViewPort(props) {
    var ref = (0,react.useState)((0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    })), isPublicDomain = ref[0], setIsPublicDomain = ref[1];
    var ref1 = (0,react.useState)(0), publicDomain = ref1[0], setPublicDomain = ref1[1];
    (0,react.useEffect)(function() {
        setPublicDomain(isPublicDomain);
    }, [
        isPublicDomain,
        setPublicDomain
    ]);
    var _$config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, _$config, props).inViewport;
    var b2description = props.details.b2b_description;
    var isHtmlEmpty = function(html) {
        if (!html) return true;
        var text = html.replace(/<[^>]*>/g, "").trim();
        return text === "";
    };
    var isPasswordProtectionEnabled = Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.passwordEnabled);
    var viewPortResult = null;
    viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: publicDomain != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isPasswordProtectionEnabled && !isHtmlEmpty(b2description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: b2description
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: publicDomain != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: myRef,
            id: "pro_detail_b2b_desc",
            className: "row full-width no-margin py-4",
            children: viewPortResult
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/LeftSide.tsx
























function LeftSide(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,i18n/* useT */.NT)();
    var isServer = (0,dist_module/* useIsSSR */.Av)();
    var isPublicDomain = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    });
    var isBookingsActive = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isBookingsActive"] == 1 && (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_bookings_activate") == 1 ? 1 : 0;
    });
    var isHotel = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHotel"];
    });
    var isChain = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean(state["appSettings"]["isChain"]);
    });
    var factsheetDocument = props.details.hasOwnProperty("factsheet_document") ? props.details.factsheet_document : null;
    var threesixtyTour = props.details.hasOwnProperty("threesixty_tour") ? props.details.threesixty_tour : null;
    var experiences = props.details.experiences;
    var show_themes = true;
    if (props.builder != null && Checkers/* default.objChildExists */.Z.objChildExists(props.builder, "builder_property_page_cat_show")) {
        show_themes = Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_property_page_cat_show);
    }
    var spaces_obj = {
        areaSqm: props.details.property_area_sqm,
        areaOutdoorSqm: props.details.property_area_outdoor_sqm,
        spaces: props.spaces
    };
    var bookingBoxPosition = props.app.builder.builder_singleproperty_booking_box_position;
    var singlePropertyData = (0,es/* useSelector */.v9)(function(state) {
        return state["singlePropertyData"]["propertyData"];
    });
    var chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null;
    var ref6 = (0,react.useState)(chainId), chain = ref6[0], setChain = ref6[1];
    (0,react.useEffect)(function() {
        setChain(chainId);
    }, [
        chainId
    ]);
    var mainClass = "col-12 col-lg-8 p-t-20";
    if (props.hideSidebar || isPublicDomain == 1 || isBookingsActive == 0 || isHotel || isChain) {
        mainClass = "col-12 col-lg-12 p-t-20";
    }
    if (bookingBoxPosition == "FIXED") {
        mainClass = "offset-1 col-10 col-lg-10 p-t-20";
    }
    var titlePositionBeforeJumbotron = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_title_position");
    });
    var moveRelatedPropertiesBelowMap = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_move_below_map"));
    });
    var areasLayoutSetting = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_layout");
    });
    var featuresBlock = !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {
        app: props.app,
        features: props.features,
        fourColumns: props.fourColumnsFeatures,
        isManager: (ref = props.app_data) === null || ref === void 0 ? void 0 : ref.is_manager
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var roomTypesAfterOverview = isHotel && props.overviewBeforeSpaces != null && !moveRelatedPropertiesBelowMap;
    // Related properties always close the content, right above the map (not between room types / chain properties)
    var showRelatedProperties = !moveRelatedPropertiesBelowMap && !props.isSingleVilla || isChain;
    var relatedPropertiesSectionActive = props.app.propertySections.some(function(section) {
        return section.type == "SYSTEM_PROPERTY_RELATED_PROPERTIES" && section.isActive;
    });
    var relatedPropertiesBlock = /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProperties, {
        propertyId: props.property_id,
        app_data: props.app_data,
        app: props.app,
        builder: props.builder,
        isHotel: false,
        isChain: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: !chainId ? mainClass : "col-12 col-lg-12 p-t-20",
        children: props.app.propertySections.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !props.hideDescription && titlePositionBeforeJumbotron != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyHeading, {
                    details: props.details,
                    location: props.location,
                    readMore: props.details.desc_brief != null || props.details.desc_details != null,
                    isChain: isChain
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain && !props.hideDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailDesc, {
                    details: props.details,
                    location: props.location,
                    readMore: props.details.desc_brief != null || props.details.desc_details != null
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                show_themes && !isChain && !props.hideThemes ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Themes, {
                    themes: props.themes
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHotel && !roomTypesAfterOverview && !moveRelatedPropertiesBelowMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BedroomsView, {
                    isHotel: true,
                    locationLabel: (ref1 = props.location) === null || ref1 === void 0 ? void 0 : ref1.address,
                    isManager: (ref2 = props.app_data) === null || ref2 === void 0 ? void 0 : ref2.is_manager
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain && !props.hideFeaturedImages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedImagesViewPort, {
                    images: props.images,
                    images_count: props.images_count,
                    all_images: props.all_images
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain && !props.mediaAfterPolicies && !props.hideMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSection, {
                    factsheetDocument: factsheetDocument,
                    threesixtyTour: threesixtyTour
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                props.profileBeforeSpaces || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                props.galleryAfterProfile || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                props.distinctsBeforeAttributes || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                props.overviewBeforeSpaces || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                roomTypesAfterOverview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BedroomsView, {
                    isHotel: true,
                    locationLabel: (ref3 = props.location) === null || ref3 === void 0 ? void 0 : ref3.address,
                    isManager: (ref4 = props.app_data) === null || ref4 === void 0 ? void 0 : ref4.is_manager
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHotel ? featuresBlock : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                Checkers/* default.displaySpaces */.Z.displaySpaces(spaces_obj, areasLayoutSetting) && !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spaces, {
                    areaSqm: spaces_obj.areaSqm,
                    areaOutdoorSqm: spaces_obj.areaOutdoorSqm,
                    spaces: spaces_obj.spaces,
                    isHotel: props.isHotel
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isHotel ? featuresBlock : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                    services: props.services,
                    page_title: props.page_title,
                    isManager: (ref5 = props.app_data) === null || ref5 === void 0 ? void 0 : ref5.is_manager
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !props.hideTerms && props.terms != undefined && props.terms.length > 0 && props.app.propertySections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsViewPort, {
                    terms: props.terms,
                    descRules: props.details.desc_rules
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain && props.mediaAfterPolicies && !props.hideMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSection, {
                    factsheetDocument: factsheetDocument,
                    threesixtyTour: threesixtyTour
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !isChain && !props.hideExperiences ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencesDestination, {
                    experiences: experiences,
                    app_data: props.app_data,
                    app: props.app,
                    builder: props.builder
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                !moveRelatedPropertiesBelowMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainPropertyData, {
                        isChain: isChain
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                showRelatedProperties ? relatedPropertiesBlock : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !props.hideDescription && titlePositionBeforeJumbotron != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyHeading, {
                    details: props.details,
                    location: props.location,
                    readMore: props.details.desc_brief != null || props.details.desc_details != null,
                    isChain: isChain
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                props.app.propertySections.map(function(section) {
                    if (!section.isActive) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    }
                    switch(section.type){
                        case "SYSTEM_PROPERTY_THEMES":
                            {
                                return show_themes && !isChain && !props.hideThemes ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Themes, {
                                    themes: props.themes
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                        case "SYSTEM_PROPERTY_B2B_DESCRIPTION":
                            {
                                return props.hideDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BDescViewPort, {
                                        details: props.details,
                                        passwordEnabled: props.app.builder.builder_properties_lock
                                    })
                                });
                            }
                        case "SYSTEM_PROPERTY_DESCRIPTION":
                            {
                                return props.hideDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailDesc, {
                                        details: props.details,
                                        location: props.location,
                                        readMore: props.details.desc_brief != null || props.details.desc_details != null
                                    })
                                });
                            }
                        case "SYSTEM_PROPERTY_GALLERY":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain && !props.hideFeaturedImages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedImagesViewPort, {
                                        images: props.images,
                                        images_count: props.images_count,
                                        all_images: props.all_images
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_MEDIA":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain && !props.hideMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSection, {
                                        factsheetDocument: factsheetDocument,
                                        threesixtyTour: threesixtyTour
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_HIGHLIGHTS":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlights, {
                                        highlights: props.highlights
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_SPACES":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain ? Checkers/* default.displaySpaces */.Z.displaySpaces(spaces_obj, areasLayoutSetting) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spaces, {
                                        areaSqm: spaces_obj.areaSqm,
                                        areaOutdoorSqm: spaces_obj.areaOutdoorSqm,
                                        spaces: spaces_obj.spaces,
                                        isHotel: props.isHotel
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_AMENITIES":
                            {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {
                                        app: props.app,
                                        features: props.features,
                                        isManager: (ref = props.app_data) === null || ref === void 0 ? void 0 : ref.is_manager
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_SERVICES":
                            {
                                var ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                                        services: props.services,
                                        page_title: props.page_title,
                                        isManager: (ref1 = props.app_data) === null || ref1 === void 0 ? void 0 : ref1.is_manager
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_TERMS":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: !isChain && !props.hideTerms && props.terms && props.app.propertySections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsViewPort, {
                                        terms: props.terms,
                                        descRules: props.details.desc_rules
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_DISTANCES":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: Checkers/* default.isValidObjString */.Z.isValidObjString(props.details, "desc_area_distances") && props.details.desc_area_distances || Checkers/* default.isValidArray */.Z.isValidArray(props.map_pois) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "pro_distances_section",
                                            className: "pb-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "m-t-5",
                                                    children: t("property.distances")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPois/* default */.Z, {
                                                    descAreaDistances: Checkers/* default.isValidObjString */.Z.isValidObjString(props.details, "desc_area_distances") && props.details.desc_area_distances,
                                                    map_pois: props.map_pois
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                });
                            }
                        case "SYSTEM_PROPERTY_EXPERIENCES":
                            {
                                return props.hideExperiences ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencesDestination, {
                                        experiences: experiences,
                                        app_data: props.app_data,
                                        app: props.app,
                                        builder: props.builder
                                    })
                                });
                            }
                        case "SYSTEM_PROPERTY_RELATED_PROPERTIES":
                            {
                                // rendered after all sections, see relatedPropertiesBlock
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                        case "SYSTEM_PROPERTY_ROOM_TYPES":
                            {
                                var ref2, ref3;
                                return !moveRelatedPropertiesBelowMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BedroomsView, {
                                        isHotel: true,
                                        locationLabel: (ref2 = props.location) === null || ref2 === void 0 ? void 0 : ref2.address,
                                        isManager: (ref3 = props.app_data) === null || ref3 === void 0 ? void 0 : ref3.is_manager
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                        case "SYSTEM_PROPERTY_CHAIN_PROPERTIES":
                            {
                                return !moveRelatedPropertiesBelowMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: isChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainPropertyData, {
                                        isChain: isChain
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                        case "SYSTEM_PROPERTY_LEGAL_LICENSE":
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(left_LegalLicenseViewPort, {
                                    details: props.details
                                });
                            }
                        // case 'SYSTEM_PROPERTY_CONTACT_FORM': {
                        //     return (
                        //         !moveRelatedPropertiesBelowMap ?
                        //             <>{!isChain ? <SinglePropertyContactForm /> : <></>}</>
                        //             :
                        //             <></>
                        //     )
                        // }
                        default:
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                    }
                }),
                showRelatedProperties && relatedPropertiesSectionActive ? relatedPropertiesBlock : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            ]
        })
    });
}

// EXTERNAL MODULE: ./helpers/class/Calendar.ts
var Calendar = __webpack_require__(19601);
// EXTERNAL MODULE: ./helpers/class/Dialog.ts
var Dialog = __webpack_require__(8557);
// EXTERNAL MODULE: ./helpers/class/Popover.ts
var Popover = __webpack_require__(81461);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog_Dialog = __webpack_require__(42492);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover_Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./components/templates/index/bookingSearchBar/partials/Guests.tsx
var Guests = __webpack_require__(12061);
// EXTERNAL MODULE: ./helpers/LgConsts.tsx
var LgConsts = __webpack_require__(34116);
// EXTERNAL MODULE: ./components/templates/property/partials/bookings/DateRangeWrapper.tsx + 1 modules
var DateRangeWrapper = __webpack_require__(4216);
// EXTERNAL MODULE: ./helpers/HandlerHelper.tsx
var HandlerHelper = __webpack_require__(7836);
// EXTERNAL MODULE: ./node_modules/react-sticky-box/dist/index.js
var react_sticky_box_dist = __webpack_require__(77134);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/right/BookNowViewPort.tsx




















function BookNow(props) {
    var dateLocale = (0,i18n/* useLocale */.bU)();
    var t = (0,i18n/* useT */.NT)();
    var config = {
        disconnectOnLeave: false
    };
    var options = {};
    var myRef = (0,react.useRef)();
    var inViewport = (0,dist_es/* useInViewport */.NM)(myRef, options, config, props).inViewport;
    var dispatch = (0,es/* useDispatch */.I0)();
    var checkin = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var priceLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["priceLoading"];
    });
    var propertyInitialAvailability = (0,es/* useSelector */.v9)(function(state) {
        return state["propertyAvailability"]["initialAvailability"];
    });
    var showIquires = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_bookings_inquires_allow");
    });
    var inquiriesOnly = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["inquiriesOnly"];
    });
    var adults = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infants = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var personsForBooking = adults + kids + infants;
    var bookingFormTriggered = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bookingFormTriggered"];
    });
    (0,react.useEffect)(function() {
        if (!propertyInitialAvailability) {
            dispatch((0,actions/* setCheckout */.k1)(null));
        }
    }, [
        propertyInitialAvailability
    ]);
    var builder = props.builder;
    var builder_booking_box_border = false;
    var builder_booking_box_shadow = false;
    var builder_booking_box_radius = 0;
    var builder_booking_box_class = "booking-orders-design-box col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0";
    if (builder != null) {
        builder_booking_box_border = Checkers/* default.isValidObjString */.Z.isValidObjString(builder, "builder_booking_box_border") ? builder.builder_booking_box_border : false;
        builder_booking_box_shadow = Checkers/* default.isValidObjString */.Z.isValidObjString(builder, "builder_booking_box_shadow") ? builder.builder_booking_box_shadow : false;
        builder_booking_box_radius = Checkers/* default.isValidObjString */.Z.isValidObjString(builder, "builder_booking_box_radius") ? builder.builder_booking_box_radius : 0;
    }
    var white_class = "bg-master-lightest";
    if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
        white_class = "bg-white";
    }
    if (builder_booking_box_border) {
        builder_booking_box_class += " b-grey b-a";
    }
    if (builder_booking_box_shadow) {
        builder_booking_box_class += " box-shadow";
    }
    if (builder_booking_box_radius > 0) {
        builder_booking_box_class += " b-radius-".concat(builder_booking_box_radius);
    }
    builder_booking_box_class += " text-center no-overflow";
    var priceValue = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["price"];
    });
    var finalPriceValue = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["finalPrice"];
    });
    var climateResilienceTax = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["climateResilienceTax"];
    });
    var showClimateResilienceTax = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean(state["builderSettingsData"]["settings"]["builder"]["page_show_climate_resilience_tax"]);
    });
    var discountValue = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["discount"];
    });
    var hasDiscount = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["hasDiscount"];
    });
    var accommondationLength = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["accommondationLength"];
    });
    var securityDeposit = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["securityDeposit"];
    });
    var dateRangeValid = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["dateRangeValid"];
    });
    var page_id = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var property_id = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    });
    var priceNeedUpdate = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["priceNeedUpdate"];
    });
    var priceInitialized = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["priceLoading"];
    });
    (0,react.useEffect)(function() {
        (0,HandlerHelper/* priceHandler */.SH)(dispatch, false, page_id, property_id, priceInitialized, checkin, checkout, priceNeedUpdate, adults, kids);
    }, [
        priceNeedUpdate,
        dateRangeValid
    ]);
    var enableButtons = (0,MethodHelper/* enableBookingBtn */.AE)(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid);
    // useEffect( () => {
    //   console.log("personsForBooking", bookingFormTriggered, personsForBooking, Checkers.isValidPositiveNumber(personsForBooking), (propertyInitialAvailability || priceLoading) && !Checkers.isValidPositiveNumber(personsForBooking) )
    // }, [personsForBooking])
    var hasError = function() {
        if (bookingFormTriggered && !enableButtons) {
            return true;
        }
        return false;
    };
    var bookingType = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bookingType"];
    });
    var hidePrices = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["hidePrices"];
    });
    var bookUrl = (0,HandlerHelper/* generateBookUrlHandler */.JM)();
    var inquiryUrl = (0,HandlerHelper/* generateIquiryUrlHandler */.qZ)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("close"), modalState = ref1[0], setModalState = ref1[1];
    var formatNumber = function(value) {
        return value.toLocaleString((0,i18n/* intlLocale */.l1)(dateLocale), {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };
    var handleShow = function(state) {
        setShow(true);
        setModalState(state);
    };
    var handleHide = function() {
        setShow(false);
        setModalState("close");
    };
    var viewPortResult = null;
    if (!inViewport) {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: myRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                height: 540,
                className: "col-12 b-rad-lg d-none d-sm-block"
            })
        });
    } else {
        viewPortResult = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: builder_booking_box_class,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white p-t-15 p-b-15",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-montserrat",
                                    children: t("booking.inquireNow")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-montserrat no-margin text-overflow p-l-10 p-r-10 small-text p-b-0",
                                    children: t("booking.needHelp")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-montserrat no-margin fs-14 p-t-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:" + props.phone,
                                        className: "text-master bold",
                                        children: props.phone
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-t-20 p-b-20 p-l-20 p-r-20 bg-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    id: "frm_02",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeWrapper/* default */.Z, {
                                                forList: false,
                                                theme: props.calendar.customTheme,
                                                isStatic: 0
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-12 text-left",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "form-group form-group-default input-group-attached m-b-0 " + (hasError() ? "has-error" : ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                id: "guests_label",
                                                                htmlFor: "guests",
                                                                className: "form-label bold",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        className: "hidden-md",
                                                                        icon: pro_regular_svg_icons/* faUserFriends */.r$M
                                                                    }),
                                                                    " ",
                                                                    t("search.guests")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "w-100 fs-14 fw-normal no-margin text-master text-truncate opacity-70 hidden-xs hidden-sm",
                                                                onClick: props.popover.handleOpen,
                                                                "aria-describedby": props.popover.id,
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                children: (0,i18n/* guestsLabel */.Sx)(t, props.popover.guestsText)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "w-100 fw-normal text-master text-truncate fs-14 no-margin opacity-70 visible-xs visible-sm visible-md",
                                                                onClick: props.dialog.handleOpen,
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                children: (0,i18n/* guestsLabel */.Sx)(t, props.popover.guestsText)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover_Popover/* default */.ZP, {
                                                                className: "hidden-xs hidden-sm",
                                                                id: props.popover.id,
                                                                open: props.popover.open,
                                                                anchorEl: props.popover.anchorEl,
                                                                onClose: props.popover.handleClose,
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left"
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                                    popover: props.popover,
                                                                    dialog: props.dialog,
                                                                    mobile: false
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog/* default */.Z, {
                                                                onClose: props.dialog.handleClose,
                                                                open: props.dialog.open,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guests/* default */.Z, {
                                                                    popover: props.popover,
                                                                    dialog: props.dialog,
                                                                    mobile: true
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: (hasError() ? "visible" : "invisible") + " fs-11 text-danger d-inline-block w-100 m-b-0",
                                                        children: [
                                                            "* ",
                                                            t("booking.fieldRequired")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                hidePrices != 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "price-wrapper",
                                    children: [
                                        priceLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            height: 16,
                                            className: "col-12 b-rad-lg"
                                        }) : hasDiscount && dateRangeValid ? // <span className={'m-l-10 text-danger fs-14'}>{discountValue} € discount</span>
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "font-montserrat all-caps small hint-text m-b-0",
                                            children: [
                                                t("booking.reducedPrice"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        textDecoration: "line-through"
                                                    },
                                                    children: [
                                                        priceValue,
                                                        " €"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "font-montserrat all-caps small hint-text m-b-0",
                                            children: [
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "font-montserrat m-t-0 m-b-0",
                                            children: priceLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                height: 32,
                                                className: "col-12 b-rad-lg"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: propertyInitialAvailability && finalPriceValue != null && dateRangeValid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        finalPriceValue,
                                                        " €"
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            lineHeight: "40px"
                                                        },
                                                        className: "fs-15",
                                                        children: t("booking.addDatesForPrice")
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "small m-b-0 m-t-0",
                                            children: [
                                                propertyInitialAvailability && finalPriceValue != null && dateRangeValid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    onClick: function() {
                                                        return handleShow("modal_detail_charges");
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    className: "text-black hint-text",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "hidden-sm",
                                                            children: t("booking.view")
                                                        }),
                                                        " ",
                                                        t("booking.details")
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-black hint-text"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RightModal/* default */.Z, {
                                                    modalName: "modal_detail_charges",
                                                    className: "slide_right",
                                                    Title: t("booking.chargesExplained"),
                                                    modalSize: "lg",
                                                    loaderStatus: false,
                                                    closeModal: function() {
                                                        handleHide();
                                                    },
                                                    show: modalState === "modal_detail_charges",
                                                    BodyRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                                                        ContentRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                                className: "table m-t-0 m-b-10",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                className: "padding-10",
                                                                                colSpan: 2,
                                                                                style: {
                                                                                    paddingLeft: "10px !important;"
                                                                                },
                                                                                children: t("booking.description")
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                                        children: [
                                                                            propertyInitialAvailability ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                children: [
                                                                                    hasDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                                    className: "padding-10 v-align-middle semi-bold",
                                                                                                    children: t("booking.discount")
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                                                    width: "1px",
                                                                                                    className: "p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold",
                                                                                                    children: [
                                                                                                        "- ",
                                                                                                        discountValue,
                                                                                                        "\xa0€"
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                                style: {
                                                                                                    borderBottom: securityDeposit ? null : "none"
                                                                                                },
                                                                                                className: "padding-10 v-align-middle semi-bold",
                                                                                                children: t.plural("booking.accommodation", accommondationLength)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                                                width: "1px",
                                                                                                style: {
                                                                                                    borderBottom: securityDeposit ? null : "none"
                                                                                                },
                                                                                                className: "p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold",
                                                                                                children: [
                                                                                                    finalPriceValue,
                                                                                                    "\xa0€"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    showClimateResilienceTax && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(climateResilienceTax) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                                    style: {
                                                                                                        borderBottom: securityDeposit ? null : "none"
                                                                                                    },
                                                                                                    className: "padding-10 v-align-middle semi-bold",
                                                                                                    children: t("booking.climateTax")
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                                                    width: "1px",
                                                                                                    style: {
                                                                                                        borderBottom: securityDeposit ? null : "none"
                                                                                                    },
                                                                                                    className: "p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold",
                                                                                                    children: [
                                                                                                        formatNumber(climateResilienceTax),
                                                                                                        "\xa0€"
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                            securityDeposit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        style: {
                                                                                            borderBottom: "none"
                                                                                        },
                                                                                        className: "padding-10 v-align-middle semi-bold",
                                                                                        children: t("booking.securityDeposit")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                                        width: "1px",
                                                                                        style: {
                                                                                            borderBottom: "none"
                                                                                        },
                                                                                        className: "p-l-10 p-t-10 p-b-10 v-align-middle semi-bold text-right bold",
                                                                                        children: [
                                                                                            securityDeposit,
                                                                                            "\xa0€"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        className: "p-r-5 v-align-middle semi-bold text-right",
                                                                                        style: {
                                                                                            borderBottom: "none"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                            className: "no-margin font-montserrat text-overflow text-editorial-dark",
                                                                                            children: t("booking.total")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        width: "1px",
                                                                                        className: "p-l-5 v-align-middle semi-bold text-right",
                                                                                        style: {
                                                                                            borderBottom: "none"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                                            className: "no-margin font-montserrat bold text-editorial-dark",
                                                                                            children: [
                                                                                                finalPriceValue,
                                                                                                "\xa0€"
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, 100)
                                            ]
                                        })
                                    ]
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: white_class + " p-t-20 p-b-20 p-l-10 p-r-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row p-r-10 p-l-10",
                                    children: [
                                        inquiriesOnly == "1" || showIquires == "1" || bookingType == LgConsts/* default.BOOKING_TYPE_1_INQUIRIES */.Z.BOOKING_TYPE_1_INQUIRIES ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            onClick: function() {
                                                dispatch((0,actions/* updateBookingFormTriggered */.Vz)(true));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "btn btn-lg btn-default btn-black full-width btn-bordered " + (enableButtons ? "" : "disabled"),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: inquiryUrl,
                                                children: t("booking.inquire")
                                            })
                                        }) : "",
                                        inquiriesOnly != "1" && Checkers/* default.isValidString */.Z.isValidString(bookUrl) && (bookingType == LgConsts/* default.BOOKING_TYPE_2_WEBHOTELIER */.Z.BOOKING_TYPE_2_WEBHOTELIER || propertyInitialAvailability && bookingType == LgConsts/* default.BOOKING_TYPE_1_INQUIRIES */.Z.BOOKING_TYPE_1_INQUIRIES) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                dispatch((0,actions/* updateBookingFormTriggered */.Vz)(true));
                                            },
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "btn btn-lg btn-primary btn-design-color full-width " + (enableButtons ? "" : "disabled"),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: bookUrl,
                                                children: t("booking.bookNow")
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "small hint-text m-t-15 m-b-5",
                                    children: t("booking.notChargedYet")
                                })
                            ]
                        })
                    ]
                }),
                Checkers/* default.isValidString */.Z.isValidString(props.legalLicense) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-t-20 p-l-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "font-arial fs-11 small-text no-margin",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hint-text text-master",
                                children: t("booking.licenseIntro")
                            }),
                            t("booking.tourismOrg"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hint-text",
                                children: t("booking.licenseNo")
                            }),
                            props.legalLicense
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_sticky_box_dist/* default */.Z, {
        offsetTop: 20,
        offsetBottom: 20,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pb-3 d-none d-sm-block",
            children: viewPortResult
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/RightSide.tsx













var SwipeableDrawerBooknow = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7899).then(__webpack_require__.bind(__webpack_require__, 77899));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77899)
            ];
        }
    },
    ssr: false
});
function RightSide(props) {
    Calendar/* default.setProps */.Z.setProps(props);
    Popover/* default.setProps */.Z.setProps(props);
    Dialog/* default.setProps */.Z.setProps(props);
    var calendarMaterialTheme = Calendar/* default.getCalendarMaterialTheme */.Z.getCalendarMaterialTheme;
    var popoverMaterialTheme = Popover/* default.getPopoverMaterialTheme */.Z.getPopoverMaterialTheme;
    var dialogMaterialTheme = Dialog/* default.getDialogMaterialTheme */.Z.getDialogMaterialTheme;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([
        null,
        null
    ]), 2), value = ref[0], setValue = ref[1];
    //-------------POP OVER----------------
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), popover_anchorEl = ref1[0], popover_setAnchorEl = ref1[1];
    var popover_handleOpen = function(event) {
        popover_setAnchorEl(event.currentTarget);
        document.getElementById("guests_label").classList.add("fade");
        document.getElementById("guests_label").parentElement.classList.add("focused");
    };
    var popover_handleClose = function() {
        document.getElementById("guests_label").classList.remove("fade");
        document.getElementById("guests_label").parentElement.classList.remove("focused");
        popover_setAnchorEl(null);
    };
    var popover_open = Boolean(popover_anchorEl);
    var popover_id = popover_open ? "simple-popover" : undefined;
    var ref2 = (0,react.useState)(0), adults_amount = ref2[0], adults_setAmount = ref2[1];
    var ref3 = (0,react.useState)(0), kids_amount = ref3[0], kids_setAmount = ref3[1];
    var ref4 = (0,react.useState)(0), infants_amount = ref4[0], infants_setAmount = ref4[1];
    var ref5 = (0,react.useState)(true), adults_decreaseHidden = ref5[0], adults_setDecreaseHidden = ref5[1];
    var ref6 = (0,react.useState)(true), kids_decreaseHidden = ref6[0], kids_setDecreaseHidden = ref6[1];
    var ref7 = (0,react.useState)(true), infants_decreaseHidden = ref7[0], infants_setDecreaseHidden = ref7[1];
    var ref8 = (0,react.useState)(false), adults_increaseHidden = ref8[0], adults_setIncreaseHidden = ref8[1];
    var ref9 = (0,react.useState)(false), kids_increaseHidden = ref9[0], kids_setIncreaseHidden = ref9[1];
    var ref10 = (0,react.useState)(false), infants_increaseHidden = ref10[0], infants_setIncreaseHidden = ref10[1];
    var ref11 = (0,react.useState)(""), guests_text = ref11[0], guests_setText = ref11[1];
    // const singlePropertyData = useSelector(state => state['singlePropertyData']['propertyData'])
    //
    // const chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null
    //
    // const [chain, setChain] = useState(chainId)
    //
    // useEffect(() => {
    //   setChain(chainId)
    // }, [chainId])
    //
    var adults_handleIncrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount + 1;
        });
        if (adults_amount + 1 > 0) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        if (adults_amount + 1 < 30) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount);
        });
    };
    var adults_handleDecrease = function() {
        adults_setAmount(function(adults_amount) {
            return adults_amount - 1;
        });
        if (adults_amount - 1 < 1) adults_setDecreaseHidden(true);
        else if ((kids_amount > 0 || infants_amount > 0) && adults_amount - 1 < 2) adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        if (adults_amount - 1 >= 0) adults_setIncreaseHidden(false);
        else adults_setIncreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(adults_amount - 1, kids_amount, infants_amount);
        });
    };
    var kids_handleIncrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount + 1;
        });
        if (kids_amount + 1 > 0) kids_setDecreaseHidden(false);
        else kids_setDecreaseHidden(true);
        if (kids_amount + 1 < 30) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(adults_amount) {
                return adults_amount + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount + 1, infants_amount);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount + 1, infants_amount);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var kids_handleDecrease = function() {
        kids_setAmount(function(kids_amount) {
            return kids_amount - 1;
        });
        if (kids_amount - 1 < 1) kids_setDecreaseHidden(true);
        else kids_setDecreaseHidden(false);
        if (kids_amount - 1 >= 0) kids_setIncreaseHidden(false);
        else kids_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount - 1 < 1 && infants_amount < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount - 1, infants_amount);
        });
    };
    var infants_handleIncrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount + 1;
        });
        if (infants_amount + 1 > 0) infants_setDecreaseHidden(false);
        else infants_setDecreaseHidden(true);
        if (infants_amount + 1 < 30) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 0) {
            adults_setAmount(function(prevState) {
                return prevState + 1;
            });
            adults_setDecreaseHidden(true);
            guests_setText(function() {
                return guestsTextCalc(adults_amount + 1, kids_amount, infants_amount + 1);
            });
        } else {
            guests_setText(function() {
                return guestsTextCalc(adults_amount, kids_amount, infants_amount + 1);
            });
            if (adults_amount < 2) adults_setDecreaseHidden(true);
            else adults_setDecreaseHidden(false);
        }
    };
    var infants_handleDecrease = function() {
        infants_setAmount(function(infants_amount) {
            return infants_amount - 1;
        });
        if (infants_amount - 1 < 1) infants_setDecreaseHidden(true);
        else infants_setDecreaseHidden(false);
        if (infants_amount - 1 >= 0) infants_setIncreaseHidden(false);
        else infants_setIncreaseHidden(true);
        if (adults_amount == 1) if (kids_amount < 1 && infants_amount - 1 < 1) adults_setDecreaseHidden(false);
        else adults_setDecreaseHidden(true);
        else adults_setDecreaseHidden(false);
        guests_setText(function() {
            return guestsTextCalc(adults_amount, kids_amount, infants_amount - 1);
        });
    };
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    (0,react.useEffect)(function() {
        var adults = parseInt(propertiesParams.adults) + parseInt(propertiesParams.kids);
        var infants = parseInt(propertiesParams.infants);
        guests_setText((0,i18n/* guestsToken */.im)([
            "adults",
            adults
        ], [
            "infants",
            infants
        ]));
    }, [
        propertiesParams
    ]);
    //-------------DIALOG-------------
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), dialog_open = ref12[0], dialog_setOpen = ref12[1];
    // const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    var dialog_handleOpen = function() {
        dialog_setOpen(true);
    };
    var dialog_handleClose = function(value) {
        dialog_setOpen(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var setGuestsAmountZero = function() {
        dispatch((0,actions/* setAdults */.MJ)(0));
        dispatch((0,actions/* setKids */.ob)(0));
        dispatch((0,actions/* setInfants */.ZG)(0));
        adults_setAmount(0);
        kids_setAmount(0);
        infants_setAmount(0);
        adults_setDecreaseHidden(true);
        kids_setDecreaseHidden(true);
        infants_setDecreaseHidden(true);
        guests_setText(function() {
            return guestsTextCalc(0, 0, 0);
        });
        dialog_handleClose("close");
    };
    var focusToggle = function(type) {
        if (document !== undefined) {
            var checkinById = document.getElementById("form-group-default-checkin");
            var checkoutById = document.getElementById("form-group-default-checkout");
            var checkin = document.querySelector(".form-group-default-checkin");
            var checkinLabel = document.querySelector("#checkin_label");
            var checkout = document.querySelector(".form-group-default-checkout");
            var checkoutLabel = document.querySelector("#checkout_label");
            switch(type){
                case "close_all":
                    checkin.classList.remove("focused");
                    checkinLabel.classList.remove("fade");
                    checkout.classList.remove("focused");
                    checkoutLabel.classList.remove("fade");
                    checkinById.blur();
                    checkoutById.blur();
                    break;
                case "close_checkin":
                    checkin.classList.remove("focused");
                    checkinLabel.classList.remove("fade");
                    checkout.classList.add("focused");
                    checkoutLabel.classList.add("fade");
                    checkinById.blur();
                    checkoutById.focus();
                    break;
                case "close_checkout":
                    checkin.classList.add("focused");
                    checkinLabel.classList.add("fade");
                    checkout.classList.remove("focused");
                    checkoutLabel.classList.remove("fade");
                    checkinById.focus();
                    checkoutById.blur();
                    break;
            }
        }
    };
    var disableWeekends = function(date) {
        return date.getDay() === 0 || date.getDay() === 6;
    };
    var disableAllDatesAfterTwoYears = function(date) {
        var value = null;
        if (Checkers/* default.objChildExists */.Z.objChildExists(props, "hasOpenCalendar") && !Checkers/* default.booleanState */.Z.booleanState(props.hasOpenCalendar)) {
            var thisDate = new Date();
            var disableAfter = new Date(thisDate.getFullYear() + 2, thisDate.getMonth(), thisDate.getDate());
            value = new Date(date.getFullYear(), date.getMonth(), date.getDate()) >= disableAfter;
        }
        return value;
    };
    var popover = {
        //-----POP_OVER Variables, Handlers-------
        adults: {
            handleIncrease: adults_handleIncrease,
            handleDecrease: adults_handleDecrease,
            decreaseHidden: adults_decreaseHidden,
            increaseHidden: adults_increaseHidden,
            setDecreaseHidden: adults_setDecreaseHidden,
            setIncreaseHidden: adults_setIncreaseHidden,
            setAmount: adults_setAmount,
            amount: adults_amount
        },
        kids: {
            handleIncrease: kids_handleIncrease,
            handleDecrease: kids_handleDecrease,
            decreaseHidden: kids_decreaseHidden,
            increaseHidden: kids_increaseHidden,
            setDecreaseHidden: kids_setDecreaseHidden,
            setIncreaseHidden: kids_setIncreaseHidden,
            setAmount: kids_setAmount,
            amount: kids_amount
        },
        infants: {
            handleIncrease: infants_handleIncrease,
            handleDecrease: infants_handleDecrease,
            decreaseHidden: infants_decreaseHidden,
            increaseHidden: infants_increaseHidden,
            setDecreaseHidden: infants_setDecreaseHidden,
            setIncreaseHidden: infants_setIncreaseHidden,
            setAmount: infants_setAmount,
            amount: infants_amount
        },
        setGuestsAmountZero: setGuestsAmountZero,
        guestsText: guests_text,
        guestsSetText: guests_setText,
        guestsTextCalc: guestsTextCalc,
        customTheme: popoverMaterialTheme,
        handleOpen: popover_handleOpen,
        handleClose: popover_handleClose,
        anchorEl: popover_anchorEl,
        open: popover_open,
        id: popover_id
    };
    var dialog = {
        handleClose: dialog_handleClose,
        handleOpen: dialog_handleOpen,
        setOpen: dialog_setOpen,
        open: dialog_open,
        customTheme: dialogMaterialTheme
    };
    var calendar = {
        value: value,
        setValue: setValue,
        customTheme: calendarMaterialTheme,
        focusToggle: focusToggle,
        disableWeekends: disableWeekends,
        disableAllDatesAfterTwoYears: disableAllDatesAfterTwoYears
    };
    var bookingBoxPosition = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_booking_box_position");
    });
    return bookingBoxPosition == "FIXED" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawerBooknow, {
            calendar: calendar
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12 col-lg-4 p-t-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow, {
                    builder: props.builder,
                    //---CALENDAR----
                    calendar: calendar,
                    //-----POP_OVER-------
                    popover: popover,
                    // DIALOG
                    dialog: dialog,
                    phone: props.phone,
                    legalLicense: props.legalLicense
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawerBooknow, {
                    calendar: calendar
                })
            ]
        })
    });
}
function guestsTextCalc(adults_amount, kids_amount, infants_amount) {
    // language-neutral token, rendered with guestsLabel() (see helpers/i18n.ts)
    return (0,i18n/* guestsToken */.im)([
        "guests",
        adults_amount + kids_amount
    ], [
        "infants",
        infants_amount
    ]);
}

;// CONCATENATED MODULE: ./components/templates/property/Content.tsx









function Content(props) {
    var ref, ref1;
    var isPublicDomain = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isPublicDomain"];
    });
    var isBookingsActive = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isBookingsActive"] == 1 && (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_bookings_activate") == 1 ? 1 : 0;
    });
    var isHotel = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHotel"];
    });
    var isChain = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isChain"];
    });
    var isSingleVilla = !((ref = props.app_data) === null || ref === void 0 ? void 0 : ref.is_manager);
    var latitude = props.location.latitude;
    var longitude = props.location.longitude;
    var googleMapShow = props.app.viewMap && Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.app.builder.builder_singleproperty_show_map);
    var googleMapApiKey = props.googleMapApiKey;
    var legalLicense = Checkers/* default.objChildExists */.Z.objChildExists(props.details, "property_legal_license") && Checkers/* default.isValidString */.Z.isValidString(props.details.property_legal_license) ? props.details.property_legal_license : null;
    var ref2 = (0,react.useState)(true), showSidebar = ref2[0], setShowSidebar = ref2[1];
    var hidePin = Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.app.builder.builder_propertylist_map_hide_pin);
    var showSidebarHandler = function() {
        if (isPublicDomain == 1 || isBookingsActive == 0) {
            setShowSidebar(false);
        }
    };
    (0,react.useEffect)(function() {
        showSidebarHandler();
    }, [
        isBookingsActive,
        isPublicDomain
    ]);
    var bookingBoxPosition = props.app.builder.builder_singleproperty_booking_box_position;
    // useEffect( () => {
    //     console.log("bookingBoxIsLeft", bookingBoxIsLeft)
    // })
    var terms = Checkers/* default.isValidString */.Z.isValidString(props.terms) ? props.terms : Checkers/* default.isValidArrayOfString */.Z.isValidArrayOfString(props.terms) ? props.terms : props.details.desc_rules;
    var moveRelatedPropertiesBelowMap = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_singleproperty_related_properties_move_below_map"));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-master-lightest",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            !props.hideSidebar && bookingBoxPosition == "LEFT" && showSidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSide, {
                                legalLicense: legalLicense,
                                phone: props.phone,
                                builder: props.builder,
                                hasOpenCalendar: props.hasOpenCalendar
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide, {
                                hideDescription: props.hideDescription,
                                hideThemes: props.hideThemes,
                                hideFeaturedImages: props.hideFeaturedImages,
                                hideExperiences: props.hideExperiences,
                                hideTerms: props.hideTerms,
                                profileBeforeSpaces: props.profileBeforeSpaces,
                                galleryAfterProfile: props.galleryAfterProfile,
                                distinctsBeforeAttributes: props.distinctsBeforeAttributes,
                                overviewBeforeSpaces: props.overviewBeforeSpaces,
                                hideMedia: props.hideMedia,
                                mediaAfterPolicies: props.mediaAfterPolicies,
                                fourColumnsFeatures: props.fourColumnsFeatures,
                                hideSidebar: props.hideSidebar,
                                app: props.app,
                                app_data: props.app_data,
                                details: props.details,
                                terms: terms,
                                location: props.location,
                                images: props.images,
                                images_count: props.images_count,
                                property_id: props.details.property_id,
                                all_images: props.all_images,
                                spaces: props.spaces,
                                features: props.features,
                                services: props.services,
                                themes: props.themes,
                                page_title: props.page_title,
                                builder: props.builder,
                                highlights: props.highlights,
                                map_pois: props.map_pois,
                                isHotel: props.isHotel,
                                isSingleVilla: isSingleVilla
                            }),
                            !props.hideSidebar && !isHotel && !isChain && bookingBoxPosition != "LEFT" && showSidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSide, {
                                legalLicense: legalLicense,
                                phone: props.phone,
                                builder: props.builder,
                                hasOpenCalendar: props.hasOpenCalendar
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                })
            }, 0),
            props.hideMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMapSection/* default */.Z, {
                app: props.app,
                googleMapApiKey: googleMapApiKey,
                googleMapShow: googleMapShow,
                property_lat: latitude,
                property_lng: longitude,
                map_pois: props.map_pois,
                hidePin: hidePin,
                descAreaDistances: Checkers/* default.isValidObjString */.Z.isValidObjString(props.details, "desc_area_distances") && props.details.desc_area_distances,
                propertyTitle: (ref1 = props.details) === null || ref1 === void 0 ? void 0 : ref1.property_title,
                propertyImages: Checkers/* default.isValidArray */.Z.isValidArray(props.images) ? props.images.map(function(image) {
                    return image.image_thumb || image.image;
                }) : [],
                propertyAddress: props.location
            }),
            moveRelatedPropertiesBelowMap && !isSingleVilla && !isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProperties, {
                    propertyId: props.property_id,
                    app_data: props.app_data,
                    app: props.app,
                    builder: props.builder,
                    slidesPerViewDesktop: 3.5,
                    isChain: true,
                    isHotel: true
                }, "related-properties")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 70263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75147);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68779);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73582);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);








function ModalPois(props) {
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var map_pois = props.map_pois;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "modal-body",
        children: [
            props.descAreaDistances ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: props.descAreaDistances
                            }
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(map_pois) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        hover: true,
                        responsive: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                            children: t("poi.name")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                            children: t("poi.type")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                            children: t("poi.distance")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                            children: t("poi.directions")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                children: map_pois.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: item.property_poi_title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                className: "px-2 py-3",
                                                children: item.property_poi_type
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                className: "px-2 py-3",
                                                children: [
                                                    item.property_poi_selected_distance == "drive" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            item.property_poi_drive_distance_in_km > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    item.property_poi_drive_distance_in_km,
                                                                    "km ",
                                                                    item.property_poi_drive_time != null ? "- " + item.property_poi_drive_time + "min" : "",
                                                                    " "
                                                                ]
                                                            }) : item.property_poi_drive_distance_in_meters > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    item.property_poi_drive_distance_in_meters,
                                                                    "m ",
                                                                    item.property_poi_drive_time != null ? "- " + item.property_poi_drive_time + "min" : ""
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faCar */ .yn$,
                                                                className: "text-master ms-1"
                                                            })
                                                        ]
                                                    }),
                                                    item.property_poi_selected_distance == "walk" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            item.property_poi_walk_distance_in_km > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    item.property_poi_walk_distance_in_km,
                                                                    "km ",
                                                                    item.property_poi_walk_time != null ? "- " + item.property_poi_walk_time + "min" : ""
                                                                ]
                                                            }) : item.property_poi_walk_distance_in_meters > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    item.property_poi_walk_distance_in_meters,
                                                                    "m ",
                                                                    item.property_poi_walk_time != null ? "- " + item.property_poi_walk_time + "min" : ""
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faPersonWalking */ .EiI,
                                                                className: "text-master ms-1"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                className: "px-2 py-3 text-center",
                                                children: item.property_poi_custom_direction != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    rel: "noreferrer",
                                                    href: item.property_poi_custom_direction,
                                                    target: "_blank",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                            icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMap */ .Wx7
                                                        }),
                                                        " ",
                                                        t("poi.directions")
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    rel: "noreferrer",
                                                    href: "https://www.google.com/maps/dir/" + item.property_poi_latitude + "," + item.property_poi_longitude + "/" + props.property_lat + "," + props.property_lng,
                                                    target: "_blank",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                            icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faMap */ .Wx7
                                                        }),
                                                        " ",
                                                        t("poi.directions")
                                                    ]
                                                })
                                            })
                                        ]
                                    }, item.property_poi_id.toString());
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ModalPois);


/***/ }),

/***/ 39227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ localizeUnits; }
/* harmony export */ });
// The API sends the property attributes as English text ("8 guests", "6 beds", "3 baths + 1 WC", "pool",
// "190 m<sup>2</sup> indoor"). Translate only the unit words, with the units.* keys of the page language.
// Languages without these keys (the Lodge leaves them in English) keep the English words.
var UNIT_WORDS = [
    "guests",
    "guest",
    "beds",
    "bed",
    "baths",
    "bath",
    "pools",
    "pool",
    "indoor",
    "outdoor"
];
function localizeUnits(value, t) {
    if (typeof value !== "string" || value === "") {
        return value;
    }
    return value.replace(new RegExp("\\b(" + UNIT_WORDS.join("|") + ")\\b", "g"), function(word) {
        var translated = t("units." + word);
        return translated && translated !== "units." + word ? translated : word;
    });
}


/***/ })

}]);